export const DistrictComparativeSales = {
    "sections": [
      {
        "columns": 12,
        "rows": 2,
        "visual": {
          "id": 1,
          "type": "advancedTable",
          "colorTheme": "colorTheme1",
          "title": "Comparative Monthly Sales",
          "binding": {
            "data": {
              "columns": [
                {
                  "name": 'Product Group',
                  "columnName": 'ItemGroupCode',
                  "width": '150px',
                  "align": "left",
                  "sortable": true,
                  "sum": false
                },
                {
                  "name": 'Jan',
                  "columnName": 'Jan',
                  "width": '125px',
                  "align": "right",
                  "sortable": true,
                  "sum": true
                },
                {
                  "name": 'Feb',
                  "columnName": 'Feb',
                  "width": '125px',
                  "align": "right",
                  "sortable": true,
                  "sum": true
                },
                {
                  "name": 'Mar',
                  "columnName": 'Mar',
                  "width": '125px',
                  "align": "right",
                  "sortable": true,
                  "sum": true
                },
                {
                  "name": 'Apr',
                  "columnName": 'Apr',
                  "width": '125px',
                  "align": "right",
                  "sortable": true,
                  "sum": true
                },
                {
                  "name": 'May',
                  "columnName": 'May',
                  "width": '125px',
                  "align": "right",
                  "sortable": true,
                  "sum": true
                },
                {
                  "name": 'Jun',
                  "columnName": 'Jun',
                  "width": '125px',
                  "align": "right",
                  "sortable": true,
                  "sum": true
                },
                {
                  "name": 'Jul',
                  "columnName": 'Jul',
                  "width": '125px',
                  "align": "right",
                  "sortable": true,
                  "sum": true
                },
                {
                  "name": 'Aug',
                  "columnName": 'Aug',
                  "width": '125px',
                  "align": "right",
                  "sortable": true,
                  "sum": true
                },
                {
                  "name": 'Sep',
                  "columnName": 'Sep',
                  "width": '125px',
                  "align": "right",
                  "sortable": true,
                  "sum": true
                },
                {
                  "name": 'Oct',
                  "columnName": 'Oct',
                  "width": '125px',
                  "align": "right",
                  "sortable": true,
                  "sum": true
                },
                {
                  "name": 'Nov',
                  "columnName": 'Nov',
                  "width": '125px',
                  "align": "right",
                  "sortable": true,
                  "sum": true
                },
                {
                  "name": 'Dec',
                  "columnName": 'Dec',
                  "width": '125px',
                  "align": "right",
                  "sortable": true,
                  "sum": true
                },
                {
                  "name": 'Total Sales',
                  "columnName": 'TotalSales',
                  "width": '125px',
                  "align": "right",
                  "sortable": true,
                  "sum": true
                }
              ],
              "title": 'DistributorName',
              "endpoint": "D20",
              "parameters": [
                { "key": "FromMonth", "value": "2024" },
                { "key": "FromYear", "value": "1" },
                { "key": "ToMonth", "value": "2024" },
                { "key": "ToYear", "value": "1" },
                { "key": "DistrictManagerCode", "value": "" },
                { "key": "ConfigTypeCode", "value": "" }
              ]
            },
            "context": {
              "point": {
                "onClick": {
                  "selectedValueColumn": "ItemGroupCode",
                  "visuals": [
                    {
                      "title": "PESO",
                      "visual": [
                        {
                          "columns": 12,
                          "rows": 2,
                          "visual": {
                            "id": 1,
                            "type": "advancedTable",
                            "colorTheme": "colorTheme1",
                            "title": "PESO",
                            "binding": {
                              "data": {
                                "columns": [
                                  {
                                    "name": 'Product Group',
                                    "columnName": 'ItemGroupCode',
                                    "width": '150px',
                                    "align": "left",
                                    "sortable": true,
                                    "sum": false
                                  },
                                  {
                                    "name": 'Jan',
                                    "columnName": 'Jan',
                                    "width": '125px',
                                    "align": "right",
                                    "sortable": true,
                                    "sum": true
                                  },
                                  {
                                    "name": 'Feb',
                                    "columnName": 'Feb',
                                    "width": '125px',
                                    "align": "right",
                                    "sortable": true,
                                    "sum": true
                                  },
                                  {
                                    "name": 'Mar',
                                    "columnName": 'Mar',
                                    "width": '125px',
                                    "align": "right",
                                    "sortable": true,
                                    "sum": true
                                  },
                                  {
                                    "name": 'Apr',
                                    "columnName": 'Apr',
                                    "width": '125px',
                                    "align": "right",
                                    "sortable": true,
                                    "sum": true
                                  },
                                  {
                                    "name": 'May',
                                    "columnName": 'May',
                                    "width": '125px',
                                    "align": "right",
                                    "sortable": true,
                                    "sum": true
                                  },
                                  {
                                    "name": 'Jun',
                                    "columnName": 'Jun',
                                    "width": '125px',
                                    "align": "right",
                                    "sortable": true,
                                    "sum": true
                                  },
                                  {
                                    "name": 'Jul',
                                    "columnName": 'Jul',
                                    "width": '125px',
                                    "align": "right",
                                    "sortable": true,
                                    "sum": true
                                  },
                                  {
                                    "name": 'Aug',
                                    "columnName": 'Aug',
                                    "width": '125px',
                                    "align": "right",
                                    "sortable": true,
                                    "sum": true
                                  },
                                  {
                                    "name": 'Sep',
                                    "columnName": 'Sep',
                                    "width": '125px',
                                    "align": "right",
                                    "sortable": true,
                                    "sum": true
                                  },
                                  {
                                    "name": 'Oct',
                                    "columnName": 'Oct',
                                    "width": '125px',
                                    "align": "right",
                                    "sortable": true,
                                    "sum": true
                                  },
                                  {
                                    "name": 'Nov',
                                    "columnName": 'Nov',
                                    "width": '125px',
                                    "align": "right",
                                    "sortable": true,
                                    "sum": true
                                  },
                                  {
                                    "name": 'Dec',
                                    "columnName": 'Dec',
                                    "width": '125px',
                                    "align": "right",
                                    "sortable": true,
                                    "sum": true
                                  },
                                  {
                                    "name": 'Total Sales',
                                    "columnName": 'TotalSales',
                                    "width": '125px',
                                    "align": "right",
                                    "sortable": true,
                                    "sum": true
                                  }
                                ],
                                "title": 'ItemGroupCode',
                                "endpoint": "D20.1",
                                "parameters": [
                                  { "key": "FromMonth", "value": "2024" },
                                  { "key": "FromYear", "value": "1" },
                                  { "key": "ToMonth", "value": "2024" },
                                  { "key": "ToYear", "value": "1" },
                                  { "key": "ItemGroupCode", "value": "" },
                                  { "key": "DistrictManagerCode", "value": "" },
                                  { "key": "ConfigTypeCode", "value": "" }
                                ]
                              },
                              "context": {
                                "point": {
                                  "onClick": {
                                    "selectedValueColumn": "ItemGroupCode",
                                    "visuals": [
                                      // {
                                      //   "title": "Region",
                                      //   "visual": [
                                      //     {
                                      //       "columns": 12,
                                      //       "rows": 2,
                                      //       "visual": {
                                      //         "id": 1,
                                      //         "type": "advancedTable",
                                      //         "colorTheme": "colorTheme1",
                                      //         "title": "Region",
                                      //         "binding": {
                                      //           "data": {
                                      //             "columns": [
                                      //               {
                                      //                 "name": 'Region',
                                      //                 "columnName": 'RegionCode',
                                      //                 "width": '110px',
                                      //                 "align": "left",
                                      //                 "sortable": true,
                                      //                 "sum": false
                                      //               },
                                      //               {
                                      //                 "name": 'Jan',
                                      //                 "columnName": 'Jan',
                                      //                 "width": '125px',
                                      //                 "align": "right",
                                      //                 "sortable": true,
                                      //                 "sum": true
                                      //               },
                                      //               {
                                      //                 "name": 'Feb',
                                      //                 "columnName": 'Feb',
                                      //                 "width": '125px',
                                      //                 "align": "right",
                                      //                 "sortable": true,
                                      //                 "sum": true
                                      //               },
                                      //               {
                                      //                 "name": 'Mar',
                                      //                 "columnName": 'Mar',
                                      //                 "width": '125px',
                                      //                 "align": "right",
                                      //                 "sortable": true,
                                      //                 "sum": true
                                      //               },
                                      //               {
                                      //                 "name": 'Apr',
                                      //                 "columnName": 'Apr',
                                      //                 "width": '125px',
                                      //                 "align": "right",
                                      //                 "sortable": true,
                                      //                 "sum": true
                                      //               },
                                      //               {
                                      //                 "name": 'May',
                                      //                 "columnName": 'May',
                                      //                 "width": '125px',
                                      //                 "align": "right",
                                      //                 "sortable": true,
                                      //                 "sum": true
                                      //               },
                                      //               {
                                      //                 "name": 'Jun',
                                      //                 "columnName": 'Jun',
                                      //                 "width": '125px',
                                      //                 "align": "right",
                                      //                 "sortable": true,
                                      //                 "sum": true
                                      //               },
                                      //               {
                                      //                 "name": 'Jul',
                                      //                 "columnName": 'Jul',
                                      //                 "width": '125px',
                                      //                 "align": "right",
                                      //                 "sortable": true,
                                      //                 "sum": true
                                      //               },
                                      //               {
                                      //                 "name": 'Aug',
                                      //                 "columnName": 'Aug',
                                      //                 "width": '125px',
                                      //                 "align": "right",
                                      //                 "sortable": true,
                                      //                 "sum": true
                                      //               },
                                      //               {
                                      //                 "name": 'Sep',
                                      //                 "columnName": 'Sep',
                                      //                 "width": '125px',
                                      //                 "align": "right",
                                      //                 "sortable": true,
                                      //                 "sum": true
                                      //               },
                                      //               {
                                      //                 "name": 'Oct',
                                      //                 "columnName": 'Oct',
                                      //                 "width": '125px',
                                      //                 "align": "right",
                                      //                 "sortable": true,
                                      //                 "sum": true
                                      //               },
                                      //               {
                                      //                 "name": 'Nov',
                                      //                 "columnName": 'Nov',
                                      //                 "width": '125px',
                                      //                 "align": "right",
                                      //                 "sortable": true,
                                      //                 "sum": true
                                      //               },
                                      //               {
                                      //                 "name": 'Dec',
                                      //                 "columnName": 'Dec',
                                      //                 "width": '125px',
                                      //                 "align": "right",
                                      //                 "sortable": true,
                                      //                 "sum": true
                                      //               },
                                      //               {
                                      //                 "name": 'Total Sales',
                                      //                 "columnName": 'TotalSales',
                                      //                 "width": '125px',
                                      //                 "align": "right",
                                      //                 "sortable": true,
                                      //                 "sum": true
                                      //               }
                                      //             ],
                                      //             "title": 'RegionCode',
                                      //             "endpoint": "D20.3",
                                      //             "parameters": [
                                      //               { "key": "FromMonth", "value": "2024" },
                                      //               { "key": "FromYear", "value": "1" },
                                      //               { "key": "ToMonth", "value": "2024" },
                                      //               { "key": "ToYear", "value": "1" },
                                      //               { "key": "ItemGroupCode", "value": "" },
                                      //               { "key": "DistrictManagerCode", "value": "" },
                                      //               { "key": "ConfigTypeCode", "value": "" }
                                      //             ]
                                      //           },
                                      //           "context": {
                                      //             "point": {
                                      //               "onClick": {
                                      //                 "selectedValueColumn": "ItemGroupCodeRegionCode",
                                      //                 "selectedTitle": "Product",
                                      //                 "visual": [
                                      //                   {
                                      //                     "columns": 12,
                                      //                     "rows": 2,
                                      //                     "visual": {
                                      //                       "id": 1,
                                      //                       "type": "advancedTable",
                                      //                       "colorTheme": "colorTheme1",
                                      //                       "title": "Product",
                                      //                       "binding": {
                                      //                         "data": {
                                      //                           "columns": [
                                      //                             {
                                      //                               "name": 'Product Name',
                                      //                               "columnName": 'ItemName',
                                      //                               "width": '200px',
                                      //                               "align": "left",
                                      //                               "sortable": true,
                                      //                               "sum": false
                                      //                             },
                                      //                             {
                                      //                               "name": 'Jan',
                                      //                               "columnName": 'Jan',
                                      //                               "width": '125px',
                                      //                               "align": "right",
                                      //                               "sortable": true,
                                      //                               "sum": true
                                      //                             },
                                      //                             {
                                      //                               "name": 'Feb',
                                      //                               "columnName": 'Feb',
                                      //                               "width": '125px',
                                      //                               "align": "right",
                                      //                               "sortable": true,
                                      //                               "sum": true
                                      //                             },
                                      //                             {
                                      //                               "name": 'Mar',
                                      //                               "columnName": 'Mar',
                                      //                               "width": '125px',
                                      //                               "align": "right",
                                      //                               "sortable": true,
                                      //                               "sum": true
                                      //                             },
                                      //                             {
                                      //                               "name": 'Apr',
                                      //                               "columnName": 'Apr',
                                      //                               "width": '125px',
                                      //                               "align": "right",
                                      //                               "sortable": true,
                                      //                               "sum": true
                                      //                             },
                                      //                             {
                                      //                               "name": 'May',
                                      //                               "columnName": 'May',
                                      //                               "width": '125px',
                                      //                               "align": "right",
                                      //                               "sortable": true,
                                      //                               "sum": true
                                      //                             },
                                      //                             {
                                      //                               "name": 'Jun',
                                      //                               "columnName": 'Jun',
                                      //                               "width": '125px',
                                      //                               "align": "right",
                                      //                               "sortable": true,
                                      //                               "sum": true
                                      //                             },
                                      //                             {
                                      //                               "name": 'Jul',
                                      //                               "columnName": 'Jul',
                                      //                               "width": '125px',
                                      //                               "align": "right",
                                      //                               "sortable": true,
                                      //                               "sum": true
                                      //                             },
                                      //                             {
                                      //                               "name": 'Aug',
                                      //                               "columnName": 'Aug',
                                      //                               "width": '125px',
                                      //                               "align": "right",
                                      //                               "sortable": true,
                                      //                               "sum": true
                                      //                             },
                                      //                             {
                                      //                               "name": 'Sep',
                                      //                               "columnName": 'Sep',
                                      //                               "width": '125px',
                                      //                               "align": "right",
                                      //                               "sortable": true,
                                      //                               "sum": true
                                      //                             },
                                      //                             {
                                      //                               "name": 'Oct',
                                      //                               "columnName": 'Oct',
                                      //                               "width": '125px',
                                      //                               "align": "right",
                                      //                               "sortable": true,
                                      //                               "sum": true
                                      //                             },
                                      //                             {
                                      //                               "name": 'Nov',
                                      //                               "columnName": 'Nov',
                                      //                               "width": '125px',
                                      //                               "align": "right",
                                      //                               "sortable": true,
                                      //                               "sum": true
                                      //                             },
                                      //                             {
                                      //                               "name": 'Dec',
                                      //                               "columnName": 'Dec',
                                      //                               "width": '125px',
                                      //                               "align": "right",
                                      //                               "sortable": true,
                                      //                               "sum": true
                                      //                             },
                                      //                             {
                                      //                               "name": 'Total Sales',
                                      //                               "columnName": 'TotalSales',
                                      //                               "width": '125px',
                                      //                               "align": "right",
                                      //                               "sortable": true,
                                      //                               "sum": true
                                      //                             }
                                      //                           ],
                                      //                           "title": 'ItemName',
                                      //                           "endpoint": "D20.5",
                                      //                           "parameters": [
                                      //                             { "key": "FromMonth", "value": "2024" },
                                      //                             { "key": "FromYear", "value": "1" },
                                      //                             { "key": "ToMonth", "value": "2024" },
                                      //                             { "key": "ToYear", "value": "1" },
                                      //                             { "key": "ItemGroupCodeRegionCode", "value": "" },
                                      //                             { "key": "DistrictManagerCode", "value": "" },
                                      //                             { "key": "ConfigTypeCode", "value": "" }
                                      //                           ]
                                      //                         },
                                      //                         "context": {
                                      //                           "point": {
                                      //                             "onClick": {
  
                                      //                             }
                                      //                           }
                                      //                         }
                                      //                       }
                                      //                     }
                                      //                   }
                                      //                 ],
                                      //               }
                                      //             }
                                      //           }
                                      //         }
                                      //       }
                                      //     }
                                      //   ]
                                      // },
                                      {
                                        "title": "District",
                                        "visual": [
                                          {
                                            "columns": 12,
                                            "rows": 2,
                                            "visual": {
                                              "id": 1,
                                              "type": "advancedTable",
                                              "colorTheme": "colorTheme1",
                                              "title": "District",
                                              "binding": {
                                                "data": {
                                                  "columns": [
                                                    {
                                                      "name": 'District Name',
                                                      "columnName": 'DistrictName',
                                                      "width": '150px',
                                                      "align": "left",
                                                      "sortable": true,
                                                      "sum": false
                                                    },
                                                    {
                                                      "name": 'Jan',
                                                      "columnName": 'Jan',
                                                      "width": '125px',
                                                      "align": "right",
                                                      "sortable": true,
                                                      "sum": true
                                                    },
                                                    {
                                                      "name": 'Feb',
                                                      "columnName": 'Feb',
                                                      "width": '125px',
                                                      "align": "right",
                                                      "sortable": true,
                                                      "sum": true
                                                    },
                                                    {
                                                      "name": 'Mar',
                                                      "columnName": 'Mar',
                                                      "width": '125px',
                                                      "align": "right",
                                                      "sortable": true,
                                                      "sum": true
                                                    },
                                                    {
                                                      "name": 'Apr',
                                                      "columnName": 'Apr',
                                                      "width": '125px',
                                                      "align": "right",
                                                      "sortable": true,
                                                      "sum": true
                                                    },
                                                    {
                                                      "name": 'May',
                                                      "columnName": 'May',
                                                      "width": '125px',
                                                      "align": "right",
                                                      "sortable": true,
                                                      "sum": true
                                                    },
                                                    {
                                                      "name": 'Jun',
                                                      "columnName": 'Jun',
                                                      "width": '125px',
                                                      "align": "right",
                                                      "sortable": true,
                                                      "sum": true
                                                    },
                                                    {
                                                      "name": 'Jul',
                                                      "columnName": 'Jul',
                                                      "width": '125px',
                                                      "align": "right",
                                                      "sortable": true,
                                                      "sum": true
                                                    },
                                                    {
                                                      "name": 'Aug',
                                                      "columnName": 'Aug',
                                                      "width": '125px',
                                                      "align": "right",
                                                      "sortable": true,
                                                      "sum": true
                                                    },
                                                    {
                                                      "name": 'Sep',
                                                      "columnName": 'Sep',
                                                      "width": '125px',
                                                      "align": "right",
                                                      "sortable": true,
                                                      "sum": true
                                                    },
                                                    {
                                                      "name": 'Oct',
                                                      "columnName": 'Oct',
                                                      "width": '125px',
                                                      "align": "right",
                                                      "sortable": true,
                                                      "sum": true
                                                    },
                                                    {
                                                      "name": 'Nov',
                                                      "columnName": 'Nov',
                                                      "width": '125px',
                                                      "align": "right",
                                                      "sortable": true,
                                                      "sum": true
                                                    },
                                                    {
                                                      "name": 'Dec',
                                                      "columnName": 'Dec',
                                                      "width": '125px',
                                                      "align": "right",
                                                      "sortable": true,
                                                      "sum": true
                                                    },
                                                    {
                                                      "name": 'Total Sales',
                                                      "columnName": 'TotalSales',
                                                      "width": '125px',
                                                      "align": "right",
                                                      "sortable": true,
                                                      "sum": true
                                                    }
                                                  ],
                                                  "title": 'DistrictName',
                                                  "endpoint": "D20.11",
                                                  "parameters": [
                                                    { "key": "FromMonth", "value": "2024" },
                                                    { "key": "FromYear", "value": "1" },
                                                    { "key": "ToMonth", "value": "2024" },
                                                    { "key": "ToYear", "value": "1" },
                                                    { "key": "ItemGroupCode", "value": "" },
                                                    { "key": "DistrictManagerCode", "value": "" },
                                                    { "key": "ConfigTypeCode", "value": "" }
                                                  ]
                                                },
                                                "context": {
                                                  "point": {
                                                    "onClick": {
                                                      "selectedValueColumn": "ItemGroupCodeDistrictName",
                                                      "selectedTitle": "Product",
                                                      "visual": [
                                                        {
                                                          "columns": 12,
                                                          "rows": 2,
                                                          "visual": {
                                                            "id": 1,
                                                            "type": "advancedTable",
                                                            "colorTheme": "colorTheme1",
                                                            "title": "Product",
                                                            "binding": {
                                                              "data": {
                                                                "columns": [
                                                                  {
                                                                    "name": 'Product Name',
                                                                    "columnName": 'ItemName',
                                                                    "width": '200px',
                                                                    "align": "left",
                                                                    "sortable": true,
                                                                    "sum": false
                                                                  },
                                                                  {
                                                                    "name": 'Jan',
                                                                    "columnName": 'Jan',
                                                                    "width": '125px',
                                                                    "align": "right",
                                                                    "sortable": true,
                                                                    "sum": true
                                                                  },
                                                                  {
                                                                    "name": 'Feb',
                                                                    "columnName": 'Feb',
                                                                    "width": '125px',
                                                                    "align": "right",
                                                                    "sortable": true,
                                                                    "sum": true
                                                                  },
                                                                  {
                                                                    "name": 'Mar',
                                                                    "columnName": 'Mar',
                                                                    "width": '125px',
                                                                    "align": "right",
                                                                    "sortable": true,
                                                                    "sum": true
                                                                  },
                                                                  {
                                                                    "name": 'Apr',
                                                                    "columnName": 'Apr',
                                                                    "width": '125px',
                                                                    "align": "right",
                                                                    "sortable": true,
                                                                    "sum": true
                                                                  },
                                                                  {
                                                                    "name": 'May',
                                                                    "columnName": 'May',
                                                                    "width": '125px',
                                                                    "align": "right",
                                                                    "sortable": true,
                                                                    "sum": true
                                                                  },
                                                                  {
                                                                    "name": 'Jun',
                                                                    "columnName": 'Jun',
                                                                    "width": '125px',
                                                                    "align": "right",
                                                                    "sortable": true,
                                                                    "sum": true
                                                                  },
                                                                  {
                                                                    "name": 'Jul',
                                                                    "columnName": 'Jul',
                                                                    "width": '125px',
                                                                    "align": "right",
                                                                    "sortable": true,
                                                                    "sum": true
                                                                  },
                                                                  {
                                                                    "name": 'Aug',
                                                                    "columnName": 'Aug',
                                                                    "width": '125px',
                                                                    "align": "right",
                                                                    "sortable": true,
                                                                    "sum": true
                                                                  },
                                                                  {
                                                                    "name": 'Sep',
                                                                    "columnName": 'Sep',
                                                                    "width": '125px',
                                                                    "align": "right",
                                                                    "sortable": true,
                                                                    "sum": true
                                                                  },
                                                                  {
                                                                    "name": 'Oct',
                                                                    "columnName": 'Oct',
                                                                    "width": '125px',
                                                                    "align": "right",
                                                                    "sortable": true,
                                                                    "sum": true
                                                                  },
                                                                  {
                                                                    "name": 'Nov',
                                                                    "columnName": 'Nov',
                                                                    "width": '125px',
                                                                    "align": "right",
                                                                    "sortable": true,
                                                                    "sum": true
                                                                  },
                                                                  {
                                                                    "name": 'Dec',
                                                                    "columnName": 'Dec',
                                                                    "width": '125px',
                                                                    "align": "right",
                                                                    "sortable": true,
                                                                    "sum": true
                                                                  },
                                                                  {
                                                                    "name": 'Total Sales',
                                                                    "columnName": 'TotalSales',
                                                                    "width": '125px',
                                                                    "align": "right",
                                                                    "sortable": true,
                                                                    "sum": true
                                                                  }
                                                                ],
                                                                "title": 'ItemName',
                                                                "endpoint": "D20.12",
                                                                "parameters": [
                                                                  { "key": "FromMonth", "value": "2024" },
                                                                  { "key": "FromYear", "value": "1" },
                                                                  { "key": "ToMonth", "value": "2024" },
                                                                  { "key": "ToYear", "value": "1" },
                                                                  { "key": "ItemGroupCodeDistrictName", "value": "" },
                                                                  { "key": "DistrictManagerCode", "value": "" },
                                                                  { "key": "ConfigTypeCode", "value": "" }
                                                                ]
                                                              },
                                                              "context": {
                                                                "point": {
                                                                  "onClick": {
  
                                                                  }
                                                                }
                                                              }
                                                            }
                                                          }
                                                        }
                                                      ],
                                                    }
                                                  }
                                                }
                                              }
                                            }
                                          }
                                        ]
                                      },
                                      {
                                        "title": "PMR",
                                        "visual": [
                                          {
                                            "columns": 12,
                                            "rows": 2,
                                            "visual": {
                                              "id": 1,
                                              "type": "advancedTable",
                                              "colorTheme": "colorTheme1",
                                              "title": "PMR",
                                              "binding": {
                                                "data": {
                                                  "columns": [
                                                    {
                                                      "name": 'PMR Code',
                                                      "columnName": 'AgentCode',
                                                      "width": '150px',
                                                      "align": "left",
                                                      "sortable": true,
                                                      "sum": false
                                                    },
                                                    {
                                                      "name": 'Employee Code',
                                                      "columnName": 'EmployeeCode',
                                                      "width": '150px',
                                                      "align": "left",
                                                      "sortable": true,
                                                      "sum": false
                                                    },
                                                    {
                                                      "name": 'PMR Name',
                                                      "columnName": 'AgentName',
                                                      "width": '200px',
                                                      "align": "left",
                                                      "sortable": true,
                                                      "sum": false
                                                    },
                                                    {
                                                      "name": 'Area Name',
                                                      "columnName": 'TerritoryName',
                                                      "width": '300px',
                                                      "align": "left",
                                                      "sortable": true,
                                                      "sum": false
                                                    },
                                                    {
                                                      "name": 'District Name',
                                                      "columnName": 'DistrictName',
                                                      "width": '150px',
                                                      "align": "left",
                                                      "sortable": true,
                                                      "sum": false
                                                    },
                                                    {
                                                      "name": 'Region',
                                                      "columnName": 'RegionCode',
                                                      "width": '110px',
                                                      "align": "left",
                                                      "sortable": true,
                                                      "sum": false
                                                    },
                                                    {
                                                      "name": 'Jan',
                                                      "columnName": 'Jan',
                                                      "width": '125px',
                                                      "align": "right",
                                                      "sortable": true,
                                                      "sum": true
                                                    },
                                                    {
                                                      "name": 'Feb',
                                                      "columnName": 'Feb',
                                                      "width": '125px',
                                                      "align": "right",
                                                      "sortable": true,
                                                      "sum": true
                                                    },
                                                    {
                                                      "name": 'Mar',
                                                      "columnName": 'Mar',
                                                      "width": '125px',
                                                      "align": "right",
                                                      "sortable": true,
                                                      "sum": true
                                                    },
                                                    {
                                                      "name": 'Apr',
                                                      "columnName": 'Apr',
                                                      "width": '125px',
                                                      "align": "right",
                                                      "sortable": true,
                                                      "sum": true
                                                    },
                                                    {
                                                      "name": 'May',
                                                      "columnName": 'May',
                                                      "width": '125px',
                                                      "align": "right",
                                                      "sortable": true,
                                                      "sum": true
                                                    },
                                                    {
                                                      "name": 'Jun',
                                                      "columnName": 'Jun',
                                                      "width": '125px',
                                                      "align": "right",
                                                      "sortable": true,
                                                      "sum": true
                                                    },
                                                    {
                                                      "name": 'Jul',
                                                      "columnName": 'Jul',
                                                      "width": '125px',
                                                      "align": "right",
                                                      "sortable": true,
                                                      "sum": true
                                                    },
                                                    {
                                                      "name": 'Aug',
                                                      "columnName": 'Aug',
                                                      "width": '125px',
                                                      "align": "right",
                                                      "sortable": true,
                                                      "sum": true
                                                    },
                                                    {
                                                      "name": 'Sep',
                                                      "columnName": 'Sep',
                                                      "width": '125px',
                                                      "align": "right",
                                                      "sortable": true,
                                                      "sum": true
                                                    },
                                                    {
                                                      "name": 'Oct',
                                                      "columnName": 'Oct',
                                                      "width": '125px',
                                                      "align": "right",
                                                      "sortable": true,
                                                      "sum": true
                                                    },
                                                    {
                                                      "name": 'Nov',
                                                      "columnName": 'Nov',
                                                      "width": '125px',
                                                      "align": "right",
                                                      "sortable": true,
                                                      "sum": true
                                                    },
                                                    {
                                                      "name": 'Dec',
                                                      "columnName": 'Dec',
                                                      "width": '125px',
                                                      "align": "right",
                                                      "sortable": true,
                                                      "sum": true
                                                    },
                                                    {
                                                      "name": 'Total Sales',
                                                      "columnName": 'TotalSales',
                                                      "width": '125px',
                                                      "align": "right",
                                                      "sortable": true,
                                                      "sum": true
                                                    }
                                                  ],
                                                  "title": 'AgentName',
                                                  "endpoint": "D20.7",
                                                  "parameters": [
                                                    { "key": "FromMonth", "value": "2024" },
                                                    { "key": "FromYear", "value": "1" },
                                                    { "key": "ToMonth", "value": "2024" },
                                                    { "key": "ToYear", "value": "1" },
                                                    { "key": "ItemGroupCode", "value": "" },
                                                    { "key": "DistrictManagerCode", "value": "" },
                                                    { "key": "ConfigTypeCode", "value": "" }
                                                  ]
                                                },
                                                "context": {
                                                  "point": {
                                                    "onClick": {
                                                      "selectedValueColumn": "ItemGroupCodeAgentCodeTerritoryDistrictRegion",
                                                      "selectedTitle": "Product",
                                                      "visual": [
                                                        {
                                                          "columns": 12,
                                                          "rows": 2,
                                                          "visual": {
                                                            "id": 1,
                                                            "type": "advancedTable",
                                                            "colorTheme": "colorTheme1",
                                                            "title": "Product",
                                                            "binding": {
                                                              "data": {
                                                                "columns": [
                                                                  {
                                                                    "name": 'Product Name',
                                                                    "columnName": 'ItemName',
                                                                    "width": '200px',
                                                                    "align": "left",
                                                                    "sortable": true,
                                                                    "sum": false
                                                                  },
                                                                  {
                                                                    "name": 'Jan',
                                                                    "columnName": 'Jan',
                                                                    "width": '125px',
                                                                    "align": "right",
                                                                    "sortable": true,
                                                                    "sum": true
                                                                  },
                                                                  {
                                                                    "name": 'Feb',
                                                                    "columnName": 'Feb',
                                                                    "width": '125px',
                                                                    "align": "right",
                                                                    "sortable": true,
                                                                    "sum": true
                                                                  },
                                                                  {
                                                                    "name": 'Mar',
                                                                    "columnName": 'Mar',
                                                                    "width": '125px',
                                                                    "align": "right",
                                                                    "sortable": true,
                                                                    "sum": true
                                                                  },
                                                                  {
                                                                    "name": 'Apr',
                                                                    "columnName": 'Apr',
                                                                    "width": '125px',
                                                                    "align": "right",
                                                                    "sortable": true,
                                                                    "sum": true
                                                                  },
                                                                  {
                                                                    "name": 'May',
                                                                    "columnName": 'May',
                                                                    "width": '125px',
                                                                    "align": "right",
                                                                    "sortable": true,
                                                                    "sum": true
                                                                  },
                                                                  {
                                                                    "name": 'Jun',
                                                                    "columnName": 'Jun',
                                                                    "width": '125px',
                                                                    "align": "right",
                                                                    "sortable": true,
                                                                    "sum": true
                                                                  },
                                                                  {
                                                                    "name": 'Jul',
                                                                    "columnName": 'Jul',
                                                                    "width": '125px',
                                                                    "align": "right",
                                                                    "sortable": true,
                                                                    "sum": true
                                                                  },
                                                                  {
                                                                    "name": 'Aug',
                                                                    "columnName": 'Aug',
                                                                    "width": '125px',
                                                                    "align": "right",
                                                                    "sortable": true,
                                                                    "sum": true
                                                                  },
                                                                  {
                                                                    "name": 'Sep',
                                                                    "columnName": 'Sep',
                                                                    "width": '125px',
                                                                    "align": "right",
                                                                    "sortable": true,
                                                                    "sum": true
                                                                  },
                                                                  {
                                                                    "name": 'Oct',
                                                                    "columnName": 'Oct',
                                                                    "width": '125px',
                                                                    "align": "right",
                                                                    "sortable": true,
                                                                    "sum": true
                                                                  },
                                                                  {
                                                                    "name": 'Nov',
                                                                    "columnName": 'Nov',
                                                                    "width": '125px',
                                                                    "align": "right",
                                                                    "sortable": true,
                                                                    "sum": true
                                                                  },
                                                                  {
                                                                    "name": 'Dec',
                                                                    "columnName": 'Dec',
                                                                    "width": '125px',
                                                                    "align": "right",
                                                                    "sortable": true,
                                                                    "sum": true
                                                                  },
                                                                  {
                                                                    "name": 'Total Sales',
                                                                    "columnName": 'TotalSales',
                                                                    "width": '125px',
                                                                    "align": "right",
                                                                    "sortable": true,
                                                                    "sum": true
                                                                  }
                                                                ],
                                                                "title": 'ItemName',
                                                                "endpoint": "D20.8",
                                                                "parameters": [
                                                                  { "key": "FromMonth", "value": "2024" },
                                                                  { "key": "FromYear", "value": "1" },
                                                                  { "key": "ToMonth", "value": "2024" },
                                                                  { "key": "ToYear", "value": "1" },
                                                                  { "key": "ItemGroupCodeAgentCodeTerritoryDistrictRegion", "value": "" },
                                                                  { "key": "DistrictManagerCode", "value": "" },
                                                                  { "key": "ConfigTypeCode", "value": "" }
                                                                ]
                                                              },
                                                              "context": {
                                                                "point": {
                                                                  "onClick": {
  
                                                                  }
                                                                }
                                                              }
                                                            }
                                                          }
                                                        }
                                                      ]
                                                    }
                                                  }
                                                }
                                              }
                                            }
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                }
                              }
                            }
                          }
                        }
                      ]
                    },
                    {
                      "title": "UNIT",
                      "visual": [
                        {
                          "columns": 12,
                          "rows": 2,
                          "visual": {
                            "id": 1,
                            "type": "advancedTable",
                            "colorTheme": "colorTheme1",
                            "title": "UNIT",
                            "binding": {
                              "data": {
                                "columns": [
                                  {
                                    "name": 'Product Group',
                                    "columnName": 'ItemGroupCode',
                                    "width": '150px',
                                    "align": "left",
                                    "sortable": true,
                                  }
                                ],
                                "title": 'ItemGroupCode',
                                "endpoint": "D20.2",
                                "parameters": [
                                  { "key": "FromMonth", "value": "2024" },
                                  { "key": "FromYear", "value": "1" },
                                  { "key": "ToMonth", "value": "2024" },
                                  { "key": "ToYear", "value": "1" },
                                  { "key": "ItemGroupCode", "value": "" },
                                  { "key": "DistrictManagerCode", "value": "" },
                                  { "key": "ConfigTypeCode", "value": "" }
                                ]
                              },
                              "context": {
                                "point": {
                                  "onClick": {
                                    "selectedValueColumn": "ItemGroupCode",
                                    "visuals": [
                                      // {
                                      //   "title": "Region",
                                      //   "visual": [
                                      //     {
                                      //       "columns": 12,
                                      //       "rows": 2,
                                      //       "visual": {
                                      //         "id": 1,
                                      //         "type": "advancedTable",
                                      //         "colorTheme": "colorTheme1",
                                      //         "title": "Region",
                                      //         "binding": {
                                      //           "data": {
                                      //             "columns": [
                                      //               {
                                      //                 "name": 'Region',
                                      //                 "columnName": 'RegionCode',
                                      //                 "width": '100px',
                                      //                 "align": "left",
                                      //                 "sortable": true,
                                      //               }
                                      //             ],
                                      //             "title": 'RegionCode',
                                      //             "endpoint": "D20.4",
                                      //             "parameters": [
                                      //               { "key": "FromMonth", "value": "2024" },
                                      //               { "key": "FromYear", "value": "1" },
                                      //               { "key": "ToMonth", "value": "2024" },
                                      //               { "key": "ToYear", "value": "1" },
                                      //               { "key": "ItemGroupCode", "value": "" },
                                      //               { "key": "DistrictManagerCode", "value": "" },
                                      //               { "key": "ConfigTypeCode", "value": "" }
                                      //             ]
                                      //           },
                                      //           "context": {
                                      //             "point": {
                                      //               "onClick": {
                                      //                 "selectedValueColumn": "ItemGroupCodeRegionCode",
                                      //                 "selectedTitle": "Product",
                                      //                 "visual": [
                                      //                   {
                                      //                     "columns": 12,
                                      //                     "rows": 2,
                                      //                     "visual": {
                                      //                       "id": 1,
                                      //                       "type": "advancedTable",
                                      //                       "colorTheme": "colorTheme1",
                                      //                       "title": "Product",
                                      //                       "binding": {
                                      //                         "data": {
                                      //                           "columns": [
                                      //                             {
                                      //                               "name": 'Product Name',
                                      //                               "columnName": 'ItemName',
                                      //                               "width": '200px',
                                      //                               "align": "left",
                                      //                               "sortable": true,
                                      //                             },
                                      //                             {
                                      //                               "name": 'Jan',
                                      //                               "columnName": 'Jan',
                                      //                               "width": '125px',
                                      //                               "align": "right",
                                      //                               "sortable": true,
                                      //                             },
                                      //                             {
                                      //                               "name": 'Feb',
                                      //                               "columnName": 'Feb',
                                      //                               "width": '125px',
                                      //                               "align": "right",
                                      //                               "sortable": true,
                                      //                             },
                                      //                             {
                                      //                               "name": 'Mar',
                                      //                               "columnName": 'Mar',
                                      //                               "width": '125px',
                                      //                               "align": "right",
                                      //                               "sortable": true,
                                      //                             },
                                      //                             {
                                      //                               "name": 'Apr',
                                      //                               "columnName": 'Apr',
                                      //                               "width": '125px',
                                      //                               "align": "right",
                                      //                               "sortable": true,
                                      //                             },
                                      //                             {
                                      //                               "name": 'May',
                                      //                               "columnName": 'May',
                                      //                               "width": '125px',
                                      //                               "align": "right",
                                      //                               "sortable": true,
                                      //                             },
                                      //                             {
                                      //                               "name": 'Jun',
                                      //                               "columnName": 'Jun',
                                      //                               "width": '125px',
                                      //                               "align": "right",
                                      //                               "sortable": true,
                                      //                             },
                                      //                             {
                                      //                               "name": 'Jul',
                                      //                               "columnName": 'Jul',
                                      //                               "width": '125px',
                                      //                               "align": "right",
                                      //                               "sortable": true,
                                      //                             },
                                      //                             {
                                      //                               "name": 'Aug',
                                      //                               "columnName": 'Aug',
                                      //                               "width": '125px',
                                      //                               "align": "right",
                                      //                               "sortable": true,
                                      //                             },
                                      //                             {
                                      //                               "name": 'Sep',
                                      //                               "columnName": 'Sep',
                                      //                               "width": '125px',
                                      //                               "align": "right",
                                      //                               "sortable": true,
                                      //                             },
                                      //                             {
                                      //                               "name": 'Oct',
                                      //                               "columnName": 'Oct',
                                      //                               "width": '125px',
                                      //                               "align": "right",
                                      //                               "sortable": true,
                                      //                             },
                                      //                             {
                                      //                               "name": 'Nov',
                                      //                               "columnName": 'Nov',
                                      //                               "width": '125px',
                                      //                               "align": "right",
                                      //                               "sortable": true,
                                      //                             },
                                      //                             {
                                      //                               "name": 'Dec',
                                      //                               "columnName": 'Dec',
                                      //                               "width": '125px',
                                      //                               "align": "right",
                                      //                               "sortable": true,
                                      //                             },
                                      //                             {
                                      //                               "name": 'Total Sales',
                                      //                               "columnName": 'TotalSales',
                                      //                               "width": '125px',
                                      //                               "align": "right",
                                      //                               "sortable": true,
                                      //                             }
                                      //                           ],
                                      //                           "title": 'ItemName',
                                      //                           "endpoint": "D20.6",
                                      //                           "parameters": [
                                      //                             { "key": "FromMonth", "value": "2024" },
                                      //                             { "key": "FromYear", "value": "1" },
                                      //                             { "key": "ToMonth", "value": "2024" },
                                      //                             { "key": "ToYear", "value": "1" },
                                      //                             { "key": "ItemGroupCodeRegionCode", "value": "" },
                                      //                             { "key": "DistrictManagerCode", "value": "" },
                                      //                             { "key": "ConfigTypeCode", "value": "" }
                                      //                           ]
                                      //                         },
                                      //                         "context": {
                                      //                           "point": {
                                      //                             "onClick": {
  
                                      //                             }
                                      //                           }
                                      //                         }
                                      //                       }
                                      //                     }
                                      //                   }
                                      //                 ],
                                      //               }
                                      //             }
                                      //           }
                                      //         }
                                      //       }
                                      //     }
                                      //   ]
                                      // },
                                      {
                                        "title": "District",
                                        "visual": [
                                          {
                                            "columns": 12,
                                            "rows": 2,
                                            "visual": {
                                              "id": 1,
                                              "type": "advancedTable",
                                              "colorTheme": "colorTheme1",
                                              "title": "District",
                                              "binding": {
                                                "data": {
                                                  "columns": [
                                                    {
                                                      "name": 'District Name',
                                                      "columnName": 'DistrictName',
                                                      "width": '150px',
                                                      "align": "left",
                                                      "sortable": true,
                                                      "sum": false
                                                    }
                                                  ],
                                                  "title": 'DistrictName',
                                                  "endpoint": "D20.13",
                                                  "parameters": [
                                                    { "key": "FromMonth", "value": "2024" },
                                                    { "key": "FromYear", "value": "1" },
                                                    { "key": "ToMonth", "value": "2024" },
                                                    { "key": "ToYear", "value": "1" },
                                                    { "key": "ItemGroupCode", "value": "" },
                                                    { "key": "DistrictManagerCode", "value": "" },
                                                    { "key": "ConfigTypeCode", "value": "" }
                                                  ]
                                                },
                                                "context": {
                                                  "point": {
                                                    "onClick": {
                                                      "selectedValueColumn": "ItemGroupCodeDistrictName",
                                                      "selectedTitle": "Product",
                                                      "visual": [
                                                        {
                                                          "columns": 12,
                                                          "rows": 2,
                                                          "visual": {
                                                            "id": 1,
                                                            "type": "advancedTable",
                                                            "colorTheme": "colorTheme1",
                                                            "title": "Product",
                                                            "binding": {
                                                              "data": {
                                                                "columns": [
                                                                  {
                                                                    "name": 'Product Name',
                                                                    "columnName": 'ItemName',
                                                                    "width": '200px',
                                                                    "align": "left",
                                                                    "sortable": true
                                                                  },
                                                                  {
                                                                    "name": 'Jan',
                                                                    "columnName": 'Jan',
                                                                    "width": '125px',
                                                                    "align": "right",
                                                                    "sortable": true
                                                                  },
                                                                  {
                                                                    "name": 'Feb',
                                                                    "columnName": 'Feb',
                                                                    "width": '125px',
                                                                    "align": "right",
                                                                    "sortable": true
                                                                  },
                                                                  {
                                                                    "name": 'Mar',
                                                                    "columnName": 'Mar',
                                                                    "width": '125px',
                                                                    "align": "right",
                                                                    "sortable": true
                                                                  },
                                                                  {
                                                                    "name": 'Apr',
                                                                    "columnName": 'Apr',
                                                                    "width": '125px',
                                                                    "align": "right",
                                                                    "sortable": true
                                                                  },
                                                                  {
                                                                    "name": 'May',
                                                                    "columnName": 'May',
                                                                    "width": '125px',
                                                                    "align": "right",
                                                                    "sortable": true
                                                                  },
                                                                  {
                                                                    "name": 'Jun',
                                                                    "columnName": 'Jun',
                                                                    "width": '125px',
                                                                    "align": "right",
                                                                    "sortable": true
                                                                  },
                                                                  {
                                                                    "name": 'Jul',
                                                                    "columnName": 'Jul',
                                                                    "width": '125px',
                                                                    "align": "right",
                                                                    "sortable": true
                                                                  },
                                                                  {
                                                                    "name": 'Aug',
                                                                    "columnName": 'Aug',
                                                                    "width": '125px',
                                                                    "align": "right",
                                                                    "sortable": true
                                                                  },
                                                                  {
                                                                    "name": 'Sep',
                                                                    "columnName": 'Sep',
                                                                    "width": '125px',
                                                                    "align": "right",
                                                                    "sortable": true
                                                                  },
                                                                  {
                                                                    "name": 'Oct',
                                                                    "columnName": 'Oct',
                                                                    "width": '125px',
                                                                    "align": "right",
                                                                    "sortable": true
                                                                  },
                                                                  {
                                                                    "name": 'Nov',
                                                                    "columnName": 'Nov',
                                                                    "width": '125px',
                                                                    "align": "right",
                                                                    "sortable": true
                                                                  },
                                                                  {
                                                                    "name": 'Dec',
                                                                    "columnName": 'Dec',
                                                                    "width": '125px',
                                                                    "align": "right",
                                                                    "sortable": true
                                                                  },
                                                                  {
                                                                    "name": 'Total Sales',
                                                                    "columnName": 'TotalSales',
                                                                    "width": '125px',
                                                                    "align": "right",
                                                                    "sortable": true,
                                                                  }
                                                                ],
                                                                "title": 'ItemName',
                                                                "endpoint": "D20.14",
                                                                "parameters": [
                                                                  { "key": "FromMonth", "value": "2024" },
                                                                  { "key": "FromYear", "value": "1" },
                                                                  { "key": "ToMonth", "value": "2024" },
                                                                  { "key": "ToYear", "value": "1" },
                                                                  { "key": "ItemGroupCodeDistrictName", "value": "" },
                                                                  { "key": "DistrictManagerCode", "value": "" },
                                                                  { "key": "ConfigTypeCode", "value": "" }
                                                                ]
                                                              },
                                                              "context": {
                                                                "point": {
                                                                  "onClick": {
  
                                                                  }
                                                                }
                                                              }
                                                            }
                                                          }
                                                        }
                                                      ],
                                                    }
                                                  }
                                                }
                                              }
                                            }
                                          }
                                        ]
                                      },
                                      {
                                        "title": "PMR",
                                        "visual": [
                                          {
                                            "columns": 12,
                                            "rows": 2,
                                            "visual": {
                                              "id": 1,
                                              "type": "advancedTable",
                                              "colorTheme": "colorTheme1",
                                              "title": "PMR",
                                              "binding": {
                                                "data": {
                                                  "columns": [
                                                    {
                                                      "name": 'PMR Code',
                                                      "columnName": 'AgentCode',
                                                      "width": '170px',
                                                      "align": "left",
                                                      "sortable": true,
                                                    },
                                                    {
                                                      "name": 'Employee Code',
                                                      "columnName": 'EmployeeCode',
                                                      "width": '170px',
                                                      "align": "left",
                                                      "sortable": true,
                                                    },
                                                    {
                                                      "name": 'PMR Name',
                                                      "columnName": 'AgentName',
                                                      "width": '200px',
                                                      "align": "left",
                                                      "sortable": true,
                                                    },
                                                    {
                                                      "name": 'Area Name',
                                                      "columnName": 'TerritoryName',
                                                      "width": '350px',
                                                      "align": "left",
                                                      "sortable": true,
                                                    },
                                                    {
                                                      "name": 'District Name',
                                                      "columnName": 'DistrictName',
                                                      "width": '200px',
                                                      "align": "left",
                                                      "sortable": true,
                                                    },
                                                    {
                                                      "name": 'Region',
                                                      "columnName": 'RegionCode',
                                                      "width": '110px',
                                                      "align": "left",
                                                      "sortable": true,
                                                    }
                                                  ],
                                                  "title": 'AgentName',
                                                  "endpoint": "D20.9",
                                                  "parameters": [
                                                    { "key": "FromMonth", "value": "2024" },
                                                    { "key": "FromYear", "value": "1" },
                                                    { "key": "ToMonth", "value": "2024" },
                                                    { "key": "ToYear", "value": "1" },
                                                    { "key": "ItemGroupCode", "value": "" },
                                                    { "key": "DistrictManagerCode", "value": "" },
                                                    { "key": "ConfigTypeCode", "value": "" }
                                                  ]
                                                },
                                                "context": {
                                                  "point": {
                                                    "onClick": {
                                                      "selectedValueColumn": "ItemGroupCodeAgentCodeTerritoryDistrictRegion",
                                                      "selectedTitle": "Product",
                                                      "visual": [
                                                        {
                                                          "columns": 12,
                                                          "rows": 2,
                                                          "visual": {
                                                            "id": 1,
                                                            "type": "advancedTable",
                                                            "colorTheme": "colorTheme1",
                                                            "title": "Product",
                                                            "binding": {
                                                              "data": {
                                                                "columns": [
                                                                  {
                                                                    "name": 'Product Name',
                                                                    "columnName": 'ItemName',
                                                                    "width": '200px',
                                                                    "align": "left",
                                                                    "sortable": true,
                                                                  },
                                                                  {
                                                                    "name": 'Jan',
                                                                    "columnName": 'Jan',
                                                                    "width": '125px',
                                                                    "align": "right",
                                                                    "sortable": true,
                                                                  },
                                                                  {
                                                                    "name": 'Feb',
                                                                    "columnName": 'Feb',
                                                                    "width": '125px',
                                                                    "align": "right",
                                                                    "sortable": true,
                                                                  },
                                                                  {
                                                                    "name": 'Mar',
                                                                    "columnName": 'Mar',
                                                                    "width": '125px',
                                                                    "align": "right",
                                                                    "sortable": true,
                                                                  },
                                                                  {
                                                                    "name": 'Apr',
                                                                    "columnName": 'Apr',
                                                                    "width": '125px',
                                                                    "align": "right",
                                                                    "sortable": true,
                                                                  },
                                                                  {
                                                                    "name": 'May',
                                                                    "columnName": 'May',
                                                                    "width": '125px',
                                                                    "align": "right",
                                                                    "sortable": true,
                                                                  },
                                                                  {
                                                                    "name": 'Jun',
                                                                    "columnName": 'Jun',
                                                                    "width": '125px',
                                                                    "align": "right",
                                                                    "sortable": true,
                                                                  },
                                                                  {
                                                                    "name": 'Jul',
                                                                    "columnName": 'Jul',
                                                                    "width": '125px',
                                                                    "align": "right",
                                                                    "sortable": true,
                                                                  },
                                                                  {
                                                                    "name": 'Aug',
                                                                    "columnName": 'Aug',
                                                                    "width": '125px',
                                                                    "align": "right",
                                                                    "sortable": true,
                                                                  },
                                                                  {
                                                                    "name": 'Sep',
                                                                    "columnName": 'Sep',
                                                                    "width": '125px',
                                                                    "align": "right",
                                                                    "sortable": true,
                                                                  },
                                                                  {
                                                                    "name": 'Oct',
                                                                    "columnName": 'Oct',
                                                                    "width": '125px',
                                                                    "align": "right",
                                                                    "sortable": true,
                                                                  },
                                                                  {
                                                                    "name": 'Nov',
                                                                    "columnName": 'Nov',
                                                                    "width": '125px',
                                                                    "align": "right",
                                                                    "sortable": true,
                                                                  },
                                                                  {
                                                                    "name": 'Dec',
                                                                    "columnName": 'Dec',
                                                                    "width": '125px',
                                                                    "align": "right",
                                                                    "sortable": true,
                                                                  },
                                                                  {
                                                                    "name": 'Total Sales',
                                                                    "columnName": 'TotalSales',
                                                                    "width": '125px',
                                                                    "align": "right",
                                                                    "sortable": true,
                                                                  }
                                                                ],
                                                                "title": 'ItemName',
                                                                "endpoint": "D20.10",
                                                                "parameters": [
                                                                  { "key": "FromMonth", "value": "2024" },
                                                                  { "key": "FromYear", "value": "1" },
                                                                  { "key": "ToMonth", "value": "2024" },
                                                                  { "key": "ToYear", "value": "1" },
                                                                  { "key": "ItemGroupCodeAgentCodeTerritoryDistrictRegion", "value": "" },
                                                                  { "key": "DistrictManagerCode", "value": "" },
                                                                  { "key": "ConfigTypeCode", "value": "" }
                                                                ]
                                                              },
                                                              "context": {
                                                                "point": {
                                                                  "onClick": {
  
                                                                  }
                                                                }
                                                              }
                                                            }
                                                          }
                                                        }
                                                      ]
                                                    }
                                                  }
                                                }
                                              }
                                            }
                                          }
                                        ]
                                      }
                                    ]
  
                                  }
                                }
                              }
                            }
                          }
                        }
                      ]
                    }
                  ]
  
                }
              }
            }
          }
        }
      },
      {
        "columns": 12,
        "rows": 2,
        "visual": {
          "id": 1,
          "type": "advancedTable",
          "colorTheme": "colorTheme1",
          "title": "Comparative Monthly Sales (Drugstore Chains)",
          "binding": {
            "data": {
              "columns": [
                {
                  "name": 'Channel',
                  "columnName": 'DistributorCode',
                  "width": '180px',
                  "align": "left",
                  "sortable": true,
                  "sum": false
                },
                {
                  "name": 'Jan',
                  "columnName": 'Jan',
                  "width": '125px',
                  "align": "right",
                  "sortable": true,
                  "sum": true
                },
                {
                  "name": 'Feb',
                  "columnName": 'Feb',
                  "width": '125px',
                  "align": "right",
                  "sortable": true,
                  "sum": true
                },
                {
                  "name": 'Mar',
                  "columnName": 'Mar',
                  "width": '125px',
                  "align": "right",
                  "sortable": true,
                  "sum": true
                },
                {
                  "name": 'Apr',
                  "columnName": 'Apr',
                  "width": '125px',
                  "align": "right",
                  "sortable": true,
                  "sum": true
                },
                {
                  "name": 'May',
                  "columnName": 'May',
                  "width": '125px',
                  "align": "right",
                  "sortable": true,
                  "sum": true
                },
                {
                  "name": 'Jun',
                  "columnName": 'Jun',
                  "width": '125px',
                  "align": "right",
                  "sortable": true,
                  "sum": true
                },
                {
                  "name": 'Jul',
                  "columnName": 'Jul',
                  "width": '125px',
                  "align": "right",
                  "sortable": true,
                  "sum": true
                },
                {
                  "name": 'Aug',
                  "columnName": 'Aug',
                  "width": '125px',
                  "align": "right",
                  "sortable": true,
                  "sum": true
                },
                {
                  "name": 'Sep',
                  "columnName": 'Sep',
                  "width": '125px',
                  "align": "right",
                  "sortable": true,
                  "sum": true
                },
                {
                  "name": 'Oct',
                  "columnName": 'Oct',
                  "width": '125px',
                  "align": "right",
                  "sortable": true,
                  "sum": true
                },
                {
                  "name": 'Nov',
                  "columnName": 'Nov',
                  "width": '125px',
                  "align": "right",
                  "sortable": true,
                  "sum": true
                },
                {
                  "name": 'Dec',
                  "columnName": 'Dec',
                  "width": '125px',
                  "align": "right",
                  "sortable": true,
                  "sum": true
                },
                {
                  "name": 'Total Sales',
                  "columnName": 'TotalSales',
                  "width": '125px',
                  "align": "right",
                  "sortable": true,
                  "sum": true
                }
              ],
              "title": 'DistributorCode',
              "endpoint": "D21",
              "parameters": [
                { "key": "FromMonth", "value": "2024" },
                { "key": "FromYear", "value": "1" },
                { "key": "ToMonth", "value": "2024" },
                { "key": "ToYear", "value": "1" },
                { "key": "DistrictManagerCode", "value": "" },
                { "key": "ConfigTypeCode", "value": "" }
              ]
            },
            "context": {
              "point": {
                "onClick": {
                  "selectedValueColumn": "DistributorCode",
                  "visuals": [
                    {
                      "title": "PESO",
                      "visual": [
                        {
                          "columns": 12,
                          "rows": 2,
                          "visual": {
                            "id": 1,
                            "type": "advancedTable",
                            "colorTheme": "colorTheme1",
                            "title": "PESO",
                            "binding": {
                              "data": {
                                "columns": [
                                  {
                                    "name": 'Channel',
                                    "columnName": 'DistributorCode',
                                    "width": '150px',
                                    "align": "left",
                                    "sortable": true,
                                    "sum": false
                                  },
                                  {
                                    "name": 'Jan',
                                    "columnName": 'Jan',
                                    "width": '125px',
                                    "align": "right",
                                    "sortable": true,
                                    "sum": true
                                  },
                                  {
                                    "name": 'Feb',
                                    "columnName": 'Feb',
                                    "width": '125px',
                                    "align": "right",
                                    "sortable": true,
                                    "sum": true
                                  },
                                  {
                                    "name": 'Mar',
                                    "columnName": 'Mar',
                                    "width": '125px',
                                    "align": "right",
                                    "sortable": true,
                                    "sum": true
                                  },
                                  {
                                    "name": 'Apr',
                                    "columnName": 'Apr',
                                    "width": '125px',
                                    "align": "right",
                                    "sortable": true,
                                    "sum": true
                                  },
                                  {
                                    "name": 'May',
                                    "columnName": 'May',
                                    "width": '125px',
                                    "align": "right",
                                    "sortable": true,
                                    "sum": true
                                  },
                                  {
                                    "name": 'Jun',
                                    "columnName": 'Jun',
                                    "width": '125px',
                                    "align": "right",
                                    "sortable": true,
                                    "sum": true
                                  },
                                  {
                                    "name": 'Jul',
                                    "columnName": 'Jul',
                                    "width": '125px',
                                    "align": "right",
                                    "sortable": true,
                                    "sum": true
                                  },
                                  {
                                    "name": 'Aug',
                                    "columnName": 'Aug',
                                    "width": '125px',
                                    "align": "right",
                                    "sortable": true,
                                    "sum": true
                                  },
                                  {
                                    "name": 'Sep',
                                    "columnName": 'Sep',
                                    "width": '125px',
                                    "align": "right",
                                    "sortable": true,
                                    "sum": true
                                  },
                                  {
                                    "name": 'Oct',
                                    "columnName": 'Oct',
                                    "width": '125px',
                                    "align": "right",
                                    "sortable": true,
                                    "sum": true
                                  },
                                  {
                                    "name": 'Nov',
                                    "columnName": 'Nov',
                                    "width": '125px',
                                    "align": "right",
                                    "sortable": true,
                                    "sum": true
                                  },
                                  {
                                    "name": 'Dec',
                                    "columnName": 'Dec',
                                    "width": '125px',
                                    "align": "right",
                                    "sortable": true,
                                    "sum": true
                                  },
                                  {
                                    "name": 'Total Sales',
                                    "columnName": 'TotalSales',
                                    "width": '125px',
                                    "align": "right",
                                    "sortable": true,
                                    "sum": true
                                  }
                                ],
                                "title": 'DistributorCode',
                                "endpoint": "D21.7",
                                "parameters": [
                                  { "key": "FromMonth", "value": "2024" },
                                  { "key": "FromYear", "value": "1" },
                                  { "key": "ToMonth", "value": "2024" },
                                  { "key": "ToYear", "value": "1" },
                                  { "key": "DistributorCode", "value": "" },
                                  { "key": "DistrictManagerCode", "value": "" },
                                  { "key": "ConfigTypeCode", "value": "" }
                                ]
                              },
                              "context": {
                                "point": {
                                  "onClick": {
                                    "selectedValueColumn": "DistributorCode",
                                    "visuals": [
                                      // {
                                      //   "title": "Region",
                                      //   "visual": [
                                      //     {
                                      //       "columns": 12,
                                      //       "rows": 2,
                                      //       "visual": {
                                      //         "id": 1,
                                      //         "type": "advancedTable",
                                      //         "colorTheme": "colorTheme1",
                                      //         "title": "Region",
                                      //         "binding": {
                                      //           "data": {
                                      //             "columns": [
                                      //               {
                                      //                 "name": 'Region',
                                      //                 "columnName": 'RegionCode',
                                      //                 "width": '100px',
                                      //                 "align": "left",
                                      //                 "sortable": true,
                                      //                 "sum": false
                                      //               },
                                      //               {
                                      //                 "name": 'Jan',
                                      //                 "columnName": 'Jan',
                                      //                 "width": '125px',
                                      //                 "align": "right",
                                      //                 "sortable": true,
                                      //                 "sum": true
                                      //               },
                                      //               {
                                      //                 "name": 'Feb',
                                      //                 "columnName": 'Feb',
                                      //                 "width": '125px',
                                      //                 "align": "right",
                                      //                 "sortable": true,
                                      //                 "sum": true
                                      //               },
                                      //               {
                                      //                 "name": 'Mar',
                                      //                 "columnName": 'Mar',
                                      //                 "width": '125px',
                                      //                 "align": "right",
                                      //                 "sortable": true,
                                      //                 "sum": true
                                      //               },
                                      //               {
                                      //                 "name": 'Apr',
                                      //                 "columnName": 'Apr',
                                      //                 "width": '125px',
                                      //                 "align": "right",
                                      //                 "sortable": true,
                                      //                 "sum": true
                                      //               },
                                      //               {
                                      //                 "name": 'May',
                                      //                 "columnName": 'May',
                                      //                 "width": '125px',
                                      //                 "align": "right",
                                      //                 "sortable": true,
                                      //                 "sum": true
                                      //               },
                                      //               {
                                      //                 "name": 'Jun',
                                      //                 "columnName": 'Jun',
                                      //                 "width": '125px',
                                      //                 "align": "right",
                                      //                 "sortable": true,
                                      //                 "sum": true
                                      //               },
                                      //               {
                                      //                 "name": 'Jul',
                                      //                 "columnName": 'Jul',
                                      //                 "width": '125px',
                                      //                 "align": "right",
                                      //                 "sortable": true,
                                      //                 "sum": true
                                      //               },
                                      //               {
                                      //                 "name": 'Aug',
                                      //                 "columnName": 'Aug',
                                      //                 "width": '125px',
                                      //                 "align": "right",
                                      //                 "sortable": true,
                                      //                 "sum": true
                                      //               },
                                      //               {
                                      //                 "name": 'Sep',
                                      //                 "columnName": 'Sep',
                                      //                 "width": '125px',
                                      //                 "align": "right",
                                      //                 "sortable": true,
                                      //                 "sum": true
                                      //               },
                                      //               {
                                      //                 "name": 'Oct',
                                      //                 "columnName": 'Oct',
                                      //                 "width": '125px',
                                      //                 "align": "right",
                                      //                 "sortable": true,
                                      //                 "sum": true
                                      //               },
                                      //               {
                                      //                 "name": 'Nov',
                                      //                 "columnName": 'Nov',
                                      //                 "width": '125px',
                                      //                 "align": "right",
                                      //                 "sortable": true,
                                      //                 "sum": true
                                      //               },
                                      //               {
                                      //                 "name": 'Dec',
                                      //                 "columnName": 'Dec',
                                      //                 "width": '125px',
                                      //                 "align": "right",
                                      //                 "sortable": true,
                                      //                 "sum": true
                                      //               },
                                      //               {
                                      //                 "name": 'Total Sales',
                                      //                 "columnName": 'TotalSales',
                                      //                 "width": '125px',
                                      //                 "align": "right",
                                      //                 "sortable": true,
                                      //                 "sum": true
                                      //               }
                                      //             ],
                                      //             "title": 'RegionCode',
                                      //             "endpoint": "D21.1",
                                      //             "parameters": [
                                      //               { "key": "FromMonth", "value": "2024" },
                                      //               { "key": "FromYear", "value": "1" },
                                      //               { "key": "ToMonth", "value": "2024" },
                                      //               { "key": "ToYear", "value": "1" },
                                      //               { "key": "DistributorCode", "value": "" },
                                      //               { "key": "DistrictManagerCode", "value": "" },
                                      //               { "key": "ConfigTypeCode", "value": "" }
                                      //             ]
                                      //           },
                                      //           "context": {
                                      //             "point": {
                                      //               "onClick": {
                                      //                 "selectedValueColumn": "DistributorCodeRegionCode",
                                      //                 "selectedTitle": "Product",
                                      //                 "visual": [
                                      //                   {
                                      //                     "columns": 12,
                                      //                     "rows": 2,
                                      //                     "visual": {
                                      //                       "id": 1,
                                      //                       "type": "advancedTable",
                                      //                       "colorTheme": "colorTheme1",
                                      //                       "title": "Product",
                                      //                       "binding": {
                                      //                         "data": {
                                      //                           "columns": [
                                      //                             {
                                      //                               "name": 'Product Name',
                                      //                               "columnName": 'ItemName',
                                      //                               "width": '200px',
                                      //                               "align": "left",
                                      //                               "sortable": true,
                                      //                               "sum": false
                                      //                             },
                                      //                             {
                                      //                               "name": 'Jan',
                                      //                               "columnName": 'Jan',
                                      //                               "width": '125px',
                                      //                               "align": "right",
                                      //                               "sortable": true,
                                      //                               "sum": true
                                      //                             },
                                      //                             {
                                      //                               "name": 'Feb',
                                      //                               "columnName": 'Feb',
                                      //                               "width": '125px',
                                      //                               "align": "right",
                                      //                               "sortable": true,
                                      //                               "sum": true
                                      //                             },
                                      //                             {
                                      //                               "name": 'Mar',
                                      //                               "columnName": 'Mar',
                                      //                               "width": '125px',
                                      //                               "align": "right",
                                      //                               "sortable": true,
                                      //                               "sum": true
                                      //                             },
                                      //                             {
                                      //                               "name": 'Apr',
                                      //                               "columnName": 'Apr',
                                      //                               "width": '125px',
                                      //                               "align": "right",
                                      //                               "sortable": true,
                                      //                               "sum": true
                                      //                             },
                                      //                             {
                                      //                               "name": 'May',
                                      //                               "columnName": 'May',
                                      //                               "width": '125px',
                                      //                               "align": "right",
                                      //                               "sortable": true,
                                      //                               "sum": true
                                      //                             },
                                      //                             {
                                      //                               "name": 'Jun',
                                      //                               "columnName": 'Jun',
                                      //                               "width": '125px',
                                      //                               "align": "right",
                                      //                               "sortable": true,
                                      //                               "sum": true
                                      //                             },
                                      //                             {
                                      //                               "name": 'Jul',
                                      //                               "columnName": 'Jul',
                                      //                               "width": '125px',
                                      //                               "align": "right",
                                      //                               "sortable": true,
                                      //                               "sum": true
                                      //                             },
                                      //                             {
                                      //                               "name": 'Aug',
                                      //                               "columnName": 'Aug',
                                      //                               "width": '125px',
                                      //                               "align": "right",
                                      //                               "sortable": true,
                                      //                               "sum": true
                                      //                             },
                                      //                             {
                                      //                               "name": 'Sep',
                                      //                               "columnName": 'Sep',
                                      //                               "width": '125px',
                                      //                               "align": "right",
                                      //                               "sortable": true,
                                      //                               "sum": true
                                      //                             },
                                      //                             {
                                      //                               "name": 'Oct',
                                      //                               "columnName": 'Oct',
                                      //                               "width": '125px',
                                      //                               "align": "right",
                                      //                               "sortable": true,
                                      //                               "sum": true
                                      //                             },
                                      //                             {
                                      //                               "name": 'Nov',
                                      //                               "columnName": 'Nov',
                                      //                               "width": '125px',
                                      //                               "align": "right",
                                      //                               "sortable": true,
                                      //                               "sum": true
                                      //                             },
                                      //                             {
                                      //                               "name": 'Dec',
                                      //                               "columnName": 'Dec',
                                      //                               "width": '125px',
                                      //                               "align": "right",
                                      //                               "sortable": true,
                                      //                               "sum": true
                                      //                             },
                                      //                             {
                                      //                               "name": 'Total Sales',
                                      //                               "columnName": 'TotalSales',
                                      //                               "width": '125px',
                                      //                               "align": "right",
                                      //                               "sortable": true,
                                      //                               "sum": true
                                      //                             }
                                      //                           ],
                                      //                           "title": 'ItemName',
                                      //                           "endpoint": "D21.3",
                                      //                           "parameters": [
                                      //                             { "key": "FromMonth", "value": "2024" },
                                      //                             { "key": "FromYear", "value": "1" },
                                      //                             { "key": "ToMonth", "value": "2024" },
                                      //                             { "key": "ToYear", "value": "1" },
                                      //                             { "key": "DistributorCodeRegionCode", "value": "" },
                                      //                             { "key": "DistrictManagerCode", "value": "" },
                                      //                             { "key": "ConfigTypeCode", "value": "" }
                                      //                           ]
                                      //                         },
                                      //                         "context": {
                                      //                           "point": {
                                      //                             "onClick": {
  
                                      //                             }
                                      //                           }
                                      //                         }
                                      //                       }
                                      //                     }
                                      //                   }
                                      //                 ]
                                      //               }
                                      //             }
                                      //           }
                                      //         }
                                      //       }
                                      //     }
                                      //   ]
                                      // },
                                      {
                                        "title": "District",
                                        "visual": [
                                          {
                                            "columns": 12,
                                            "rows": 2,
                                            "visual": {
                                              "id": 1,
                                              "type": "advancedTable",
                                              "colorTheme": "colorTheme1",
                                              "title": "District",
                                              "binding": {
                                                "data": {
                                                  "columns": [
                                                    {
                                                      "name": 'District',
                                                      "columnName": 'DistrictName',
                                                      "width": '150px',
                                                      "align": "left",
                                                      "sortable": true,
                                                      "sum": false
                                                    },
                                                    {
                                                      "name": 'Jan',
                                                      "columnName": 'Jan',
                                                      "width": '125px',
                                                      "align": "right",
                                                      "sortable": true,
                                                      "sum": true
                                                    },
                                                    {
                                                      "name": 'Feb',
                                                      "columnName": 'Feb',
                                                      "width": '125px',
                                                      "align": "right",
                                                      "sortable": true,
                                                      "sum": true
                                                    },
                                                    {
                                                      "name": 'Mar',
                                                      "columnName": 'Mar',
                                                      "width": '125px',
                                                      "align": "right",
                                                      "sortable": true,
                                                      "sum": true
                                                    },
                                                    {
                                                      "name": 'Apr',
                                                      "columnName": 'Apr',
                                                      "width": '125px',
                                                      "align": "right",
                                                      "sortable": true,
                                                      "sum": true
                                                    },
                                                    {
                                                      "name": 'May',
                                                      "columnName": 'May',
                                                      "width": '125px',
                                                      "align": "right",
                                                      "sortable": true,
                                                      "sum": true
                                                    },
                                                    {
                                                      "name": 'Jun',
                                                      "columnName": 'Jun',
                                                      "width": '125px',
                                                      "align": "right",
                                                      "sortable": true,
                                                      "sum": true
                                                    },
                                                    {
                                                      "name": 'Jul',
                                                      "columnName": 'Jul',
                                                      "width": '125px',
                                                      "align": "right",
                                                      "sortable": true,
                                                      "sum": true
                                                    },
                                                    {
                                                      "name": 'Aug',
                                                      "columnName": 'Aug',
                                                      "width": '125px',
                                                      "align": "right",
                                                      "sortable": true,
                                                      "sum": true
                                                    },
                                                    {
                                                      "name": 'Sep',
                                                      "columnName": 'Sep',
                                                      "width": '125px',
                                                      "align": "right",
                                                      "sortable": true,
                                                      "sum": true
                                                    },
                                                    {
                                                      "name": 'Oct',
                                                      "columnName": 'Oct',
                                                      "width": '125px',
                                                      "align": "right",
                                                      "sortable": true,
                                                      "sum": true
                                                    },
                                                    {
                                                      "name": 'Nov',
                                                      "columnName": 'Nov',
                                                      "width": '125px',
                                                      "align": "right",
                                                      "sortable": true,
                                                      "sum": true
                                                    },
                                                    {
                                                      "name": 'Dec',
                                                      "columnName": 'Dec',
                                                      "width": '125px',
                                                      "align": "right",
                                                      "sortable": true,
                                                      "sum": true
                                                    },
                                                    {
                                                      "name": 'Total Sales',
                                                      "columnName": 'TotalSales',
                                                      "width": '125px',
                                                      "align": "right",
                                                      "sortable": true,
                                                      "sum": true
                                                    }
                                                  ],
                                                  "title": 'DistrictName',
                                                  "endpoint": "D21.11",
                                                  "parameters": [
                                                    { "key": "FromMonth", "value": "2024" },
                                                    { "key": "FromYear", "value": "1" },
                                                    { "key": "ToMonth", "value": "2024" },
                                                    { "key": "ToYear", "value": "1" },
                                                    { "key": "DistributorCode", "value": "" },
                                                    { "key": "DistrictManagerCode", "value": "" },
                                                    { "key": "ConfigTypeCode", "value": "" }
                                                  ]
                                                },
                                                "context": {
                                                  "point": {
                                                    "onClick": {
                                                      "selectedValueColumn": "DistributorCodeDistrictName",
                                                      "selectedTitle": "Product",
                                                      "visual": [
                                                        {
                                                          "columns": 12,
                                                          "rows": 2,
                                                          "visual": {
                                                            "id": 1,
                                                            "type": "advancedTable",
                                                            "colorTheme": "colorTheme1",
                                                            "title": "Product",
                                                            "binding": {
                                                              "data": {
                                                                "columns": [
                                                                  {
                                                                    "name": 'Product Name',
                                                                    "columnName": 'ItemName',
                                                                    "width": '200px',
                                                                    "align": "left",
                                                                    "sortable": true,
                                                                    "sum": false
                                                                  },
                                                                  {
                                                                    "name": 'Jan',
                                                                    "columnName": 'Jan',
                                                                    "width": '125px',
                                                                    "align": "right",
                                                                    "sortable": true,
                                                                    "sum": true
                                                                  },
                                                                  {
                                                                    "name": 'Feb',
                                                                    "columnName": 'Feb',
                                                                    "width": '125px',
                                                                    "align": "right",
                                                                    "sortable": true,
                                                                    "sum": true
                                                                  },
                                                                  {
                                                                    "name": 'Mar',
                                                                    "columnName": 'Mar',
                                                                    "width": '125px',
                                                                    "align": "right",
                                                                    "sortable": true,
                                                                    "sum": true
                                                                  },
                                                                  {
                                                                    "name": 'Apr',
                                                                    "columnName": 'Apr',
                                                                    "width": '125px',
                                                                    "align": "right",
                                                                    "sortable": true,
                                                                    "sum": true
                                                                  },
                                                                  {
                                                                    "name": 'May',
                                                                    "columnName": 'May',
                                                                    "width": '125px',
                                                                    "align": "right",
                                                                    "sortable": true,
                                                                    "sum": true
                                                                  },
                                                                  {
                                                                    "name": 'Jun',
                                                                    "columnName": 'Jun',
                                                                    "width": '125px',
                                                                    "align": "right",
                                                                    "sortable": true,
                                                                    "sum": true
                                                                  },
                                                                  {
                                                                    "name": 'Jul',
                                                                    "columnName": 'Jul',
                                                                    "width": '125px',
                                                                    "align": "right",
                                                                    "sortable": true,
                                                                    "sum": true
                                                                  },
                                                                  {
                                                                    "name": 'Aug',
                                                                    "columnName": 'Aug',
                                                                    "width": '125px',
                                                                    "align": "right",
                                                                    "sortable": true,
                                                                    "sum": true
                                                                  },
                                                                  {
                                                                    "name": 'Sep',
                                                                    "columnName": 'Sep',
                                                                    "width": '125px',
                                                                    "align": "right",
                                                                    "sortable": true,
                                                                    "sum": true
                                                                  },
                                                                  {
                                                                    "name": 'Oct',
                                                                    "columnName": 'Oct',
                                                                    "width": '125px',
                                                                    "align": "right",
                                                                    "sortable": true,
                                                                    "sum": true
                                                                  },
                                                                  {
                                                                    "name": 'Nov',
                                                                    "columnName": 'Nov',
                                                                    "width": '125px',
                                                                    "align": "right",
                                                                    "sortable": true,
                                                                    "sum": true
                                                                  },
                                                                  {
                                                                    "name": 'Dec',
                                                                    "columnName": 'Dec',
                                                                    "width": '125px',
                                                                    "align": "right",
                                                                    "sortable": true,
                                                                    "sum": true
                                                                  },
                                                                  {
                                                                    "name": 'Total Sales',
                                                                    "columnName": 'TotalSales',
                                                                    "width": '125px',
                                                                    "align": "right",
                                                                    "sortable": true,
                                                                    "sum": true
                                                                  }
                                                                ],
                                                                "title": 'ItemName',
                                                                "endpoint": "D21.12",
                                                                "parameters": [
                                                                  { "key": "FromMonth", "value": "2024" },
                                                                  { "key": "FromYear", "value": "1" },
                                                                  { "key": "ToMonth", "value": "2024" },
                                                                  { "key": "ToYear", "value": "1" },
                                                                  { "key": "DistributorCodeDistrictName", "value": "" },
                                                                  { "key": "DistrictManagerCode", "value": "" },
                                                                  { "key": "ConfigTypeCode", "value": "" }
                                                                ]
                                                              },
                                                              "context": {
                                                                "point": {
                                                                  "onClick": {
  
                                                                  }
                                                                }
                                                              }
                                                            }
                                                          }
                                                        }
                                                      ]
                                                    }
                                                  }
                                                }
                                              }
                                            }
                                          }
                                        ]
                                      },
                                      {
                                        "title": "PMR",
                                        "visual": [
                                          {
                                            "columns": 12,
                                            "rows": 2,
                                            "visual": {
                                              "id": 1,
                                              "type": "advancedTable",
                                              "colorTheme": "colorTheme1",
                                              "title": "PMR",
                                              "binding": {
                                                "data": {
                                                  "columns": [
                                                    {
                                                      "name": 'PMR Code',
                                                      "columnName": 'AgentCode',
                                                      "width": '150px',
                                                      "align": "left",
                                                      "sortable": true,
                                                      "sum": false
                                                    },
                                                    {
                                                      "name": 'Employee Code',
                                                      "columnName": 'EmployeeCode',
                                                      "width": '150px',
                                                      "align": "left",
                                                      "sortable": true,
                                                      "sum": false
                                                    },
                                                    {
                                                      "name": 'PMR Name',
                                                      "columnName": 'AgentName',
                                                      "width": '200px',
                                                      "align": "left",
                                                      "sortable": true,
                                                      "sum": false
                                                    },
                                                    {
                                                      "name": 'Area Name',
                                                      "columnName": 'TerritoryName',
                                                      "width": '300px',
                                                      "align": "left",
                                                      "sortable": true,
                                                      "sum": false
                                                    },
                                                    {
                                                      "name": 'District Name',
                                                      "columnName": 'DistrictName',
                                                      "width": '150px',
                                                      "align": "left",
                                                      "sortable": true,
                                                      "sum": false
                                                    },
                                                    {
                                                      "name": 'Region',
                                                      "columnName": 'RegionCode',
                                                      "width": '110px',
                                                      "align": "left",
                                                      "sortable": true,
                                                      "sum": false
                                                    },
                                                    {
                                                      "name": 'Jan',
                                                      "columnName": 'Jan',
                                                      "width": '125px',
                                                      "align": "right",
                                                      "sortable": true,
                                                      "sum": true
                                                    },
                                                    {
                                                      "name": 'Feb',
                                                      "columnName": 'Feb',
                                                      "width": '125px',
                                                      "align": "right",
                                                      "sortable": true,
                                                      "sum": true
                                                    },
                                                    {
                                                      "name": 'Mar',
                                                      "columnName": 'Mar',
                                                      "width": '125px',
                                                      "align": "right",
                                                      "sortable": true,
                                                      "sum": true
                                                    },
                                                    {
                                                      "name": 'Apr',
                                                      "columnName": 'Apr',
                                                      "width": '125px',
                                                      "align": "right",
                                                      "sortable": true,
                                                      "sum": true
                                                    },
                                                    {
                                                      "name": 'May',
                                                      "columnName": 'May',
                                                      "width": '125px',
                                                      "align": "right",
                                                      "sortable": true,
                                                      "sum": true
                                                    },
                                                    {
                                                      "name": 'Jun',
                                                      "columnName": 'Jun',
                                                      "width": '125px',
                                                      "align": "right",
                                                      "sortable": true,
                                                      "sum": true
                                                    },
                                                    {
                                                      "name": 'Jul',
                                                      "columnName": 'Jul',
                                                      "width": '125px',
                                                      "align": "right",
                                                      "sortable": true,
                                                      "sum": true
                                                    },
                                                    {
                                                      "name": 'Aug',
                                                      "columnName": 'Aug',
                                                      "width": '125px',
                                                      "align": "right",
                                                      "sortable": true,
                                                      "sum": true
                                                    },
                                                    {
                                                      "name": 'Sep',
                                                      "columnName": 'Sep',
                                                      "width": '125px',
                                                      "align": "right",
                                                      "sortable": true,
                                                      "sum": true
                                                    },
                                                    {
                                                      "name": 'Oct',
                                                      "columnName": 'Oct',
                                                      "width": '125px',
                                                      "align": "right",
                                                      "sortable": true,
                                                      "sum": true
                                                    },
                                                    {
                                                      "name": 'Nov',
                                                      "columnName": 'Nov',
                                                      "width": '125px',
                                                      "align": "right",
                                                      "sortable": true,
                                                      "sum": true
                                                    },
                                                    {
                                                      "name": 'Dec',
                                                      "columnName": 'Dec',
                                                      "width": '125px',
                                                      "align": "right",
                                                      "sortable": true,
                                                      "sum": true
                                                    },
                                                    {
                                                      "name": 'Total Sales',
                                                      "columnName": 'TotalSales',
                                                      "width": '125px',
                                                      "align": "right",
                                                      "sortable": true,
                                                      "sum": true
                                                    }
                                                  ],
                                                  "title": 'AgentName',
                                                  "endpoint": "D21.2",
                                                  "parameters": [
                                                    { "key": "FromMonth", "value": "2024" },
                                                    { "key": "FromYear", "value": "1" },
                                                    { "key": "ToMonth", "value": "2024" },
                                                    { "key": "ToYear", "value": "1" },
                                                    { "key": "DistributorCode", "value": "" },
                                                    { "key": "DistrictManagerCode", "value": "" },
                                                    { "key": "ConfigTypeCode", "value": "" }
                                                  ]
                                                },
                                                "context": {
                                                  "point": {
                                                    "onClick": {
                                                      "selectedValueColumn": "DistributorCodeAgentCodeTerritoryDistrictRegion",
                                                      "selectedTitle": "Product",
                                                      "visual": [
                                                        {
                                                          "columns": 12,
                                                          "rows": 2,
                                                          "visual": {
                                                            "id": 1,
                                                            "type": "advancedTable",
                                                            "colorTheme": "colorTheme1",
                                                            "title": "Product",
                                                            "binding": {
                                                              "data": {
                                                                "columns": [
                                                                  {
                                                                    "name": 'Product Name',
                                                                    "columnName": 'ItemName',
                                                                    "width": '200px',
                                                                    "align": "left",
                                                                    "sortable": true,
                                                                    "sum": false
                                                                  },
                                                                  {
                                                                    "name": 'Jan',
                                                                    "columnName": 'Jan',
                                                                    "width": '125px',
                                                                    "align": "right",
                                                                    "sortable": true,
                                                                    "sum": true
                                                                  },
                                                                  {
                                                                    "name": 'Feb',
                                                                    "columnName": 'Feb',
                                                                    "width": '125px',
                                                                    "align": "right",
                                                                    "sortable": true,
                                                                    "sum": true
                                                                  },
                                                                  {
                                                                    "name": 'Mar',
                                                                    "columnName": 'Mar',
                                                                    "width": '125px',
                                                                    "align": "right",
                                                                    "sortable": true,
                                                                    "sum": true
                                                                  },
                                                                  {
                                                                    "name": 'Apr',
                                                                    "columnName": 'Apr',
                                                                    "width": '125px',
                                                                    "align": "right",
                                                                    "sortable": true,
                                                                    "sum": true
                                                                  },
                                                                  {
                                                                    "name": 'May',
                                                                    "columnName": 'May',
                                                                    "width": '125px',
                                                                    "align": "right",
                                                                    "sortable": true,
                                                                    "sum": true
                                                                  },
                                                                  {
                                                                    "name": 'Jun',
                                                                    "columnName": 'Jun',
                                                                    "width": '125px',
                                                                    "align": "right",
                                                                    "sortable": true,
                                                                    "sum": true
                                                                  },
                                                                  {
                                                                    "name": 'Jul',
                                                                    "columnName": 'Jul',
                                                                    "width": '125px',
                                                                    "align": "right",
                                                                    "sortable": true,
                                                                    "sum": true
                                                                  },
                                                                  {
                                                                    "name": 'Aug',
                                                                    "columnName": 'Aug',
                                                                    "width": '125px',
                                                                    "align": "right",
                                                                    "sortable": true,
                                                                    "sum": true
                                                                  },
                                                                  {
                                                                    "name": 'Sep',
                                                                    "columnName": 'Sep',
                                                                    "width": '125px',
                                                                    "align": "right",
                                                                    "sortable": true,
                                                                    "sum": true
                                                                  },
                                                                  {
                                                                    "name": 'Oct',
                                                                    "columnName": 'Oct',
                                                                    "width": '125px',
                                                                    "align": "right",
                                                                    "sortable": true,
                                                                    "sum": true
                                                                  },
                                                                  {
                                                                    "name": 'Nov',
                                                                    "columnName": 'Nov',
                                                                    "width": '125px',
                                                                    "align": "right",
                                                                    "sortable": true,
                                                                    "sum": true
                                                                  },
                                                                  {
                                                                    "name": 'Dec',
                                                                    "columnName": 'Dec',
                                                                    "width": '125px',
                                                                    "align": "right",
                                                                    "sortable": true,
                                                                    "sum": true
                                                                  },
                                                                  {
                                                                    "name": 'Total Sales',
                                                                    "columnName": 'TotalSales',
                                                                    "width": '125px',
                                                                    "align": "right",
                                                                    "sortable": true,
                                                                    "sum": true
                                                                  }
                                                                ],
                                                                "title": 'ItemName',
                                                                "endpoint": "D21.5",
                                                                "parameters": [
                                                                  { "key": "FromMonth", "value": "2024" },
                                                                  { "key": "FromYear", "value": "1" },
                                                                  { "key": "ToMonth", "value": "2024" },
                                                                  { "key": "ToYear", "value": "1" },
                                                                  { "key": "DistributorCodeAgentCodeTerritoryDistrictRegion", "value": "" },
                                                                  { "key": "DistrictManagerCode", "value": "" },
                                                                  { "key": "ConfigTypeCode", "value": "" }
                                                                ]
                                                              },
                                                              "context": {
                                                                "point": {
                                                                  "onClick": {
  
                                                                  }
                                                                }
                                                              }
                                                            }
                                                          }
                                                        }
                                                      ]
                                                    }
                                                  }
                                                }
                                              }
                                            }
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                }
                              }
                            }
                          }
                        }
                      ]
                    },
                    {
                      "title": "UNIT",
                      "visual": [
                        {
                          "columns": 12,
                          "rows": 2,
                          "visual": {
                            "id": 1,
                            "type": "advancedTable",
                            "colorTheme": "colorTheme1",
                            "title": "UNIT",
                            "binding": {
                              "data": {
                                "columns": [
                                  {
                                    "name": 'Channel',
                                    "columnName": 'DistributorCode',
                                    "width": '180px',
                                    "align": "left",
                                    "sortable": true,
                                    "sum": false
                                  }
                                ],
                                "title": 'DistributorCode',
                                "endpoint": "D21.8",
                                "parameters": [
                                  { "key": "FromMonth", "value": "2024" },
                                  { "key": "FromYear", "value": "1" },
                                  { "key": "ToMonth", "value": "2024" },
                                  { "key": "ToYear", "value": "1" },
                                  { "key": "DistributorCode", "value": "" },
                                  { "key": "DistrictManagerCode", "value": "" },
                                  { "key": "ConfigTypeCode", "value": "" }
                                ]
                              },
                              "context": {
                                "point": {
                                  "onClick": {
                                    "selectedValueColumn": "DistributorCode",
                                    "visuals": [
                                      // {
                                      //   "title": "Region",
                                      //   "visual": [
                                      //     {
                                      //       "columns": 12,
                                      //       "rows": 2,
                                      //       "visual": {
                                      //         "id": 1,
                                      //         "type": "advancedTable",
                                      //         "colorTheme": "colorTheme1",
                                      //         "title": "Region",
                                      //         "binding": {
                                      //           "data": {
                                      //             "columns": [
                                      //               {
                                      //                 "name": 'Region',
                                      //                 "columnName": 'RegionCode',
                                      //                 "width": '100px',
                                      //                 "align": "left",
                                      //                 "sortable": true,
                                      //               }
                                      //             ],
                                      //             "title": 'RegionCode',
                                      //             "endpoint": "D21.9",
                                      //             "parameters": [
                                      //               { "key": "FromMonth", "value": "2024" },
                                      //               { "key": "FromYear", "value": "1" },
                                      //               { "key": "ToMonth", "value": "2024" },
                                      //               { "key": "ToYear", "value": "1" },
                                      //               { "key": "DistributorCode", "value": "" },
                                      //               { "key": "DistrictManagerCode", "value": "" },
                                      //               { "key": "ConfigTypeCode", "value": "" }
                                      //             ]
                                      //           },
                                      //           "context": {
                                      //             "point": {
                                      //               "onClick": {
                                      //                 "selectedValueColumn": "DistributorCodeRegionCode",
                                      //                 "selectedTitle": "Product",
                                      //                 "visual": [
                                      //                   {
                                      //                     "columns": 12,
                                      //                     "rows": 2,
                                      //                     "visual": {
                                      //                       "id": 1,
                                      //                       "type": "advancedTable",
                                      //                       "colorTheme": "colorTheme1",
                                      //                       "title": "Product",
                                      //                       "binding": {
                                      //                         "data": {
                                      //                           "columns": [
                                      //                             {
                                      //                               "name": 'Product Name',
                                      //                               "columnName": 'ItemName',
                                      //                               "width": '200px',
                                      //                               "align": "left",
                                      //                               "sortable": true,
                                      //                             },
                                      //                             {
                                      //                               "name": 'Jan',
                                      //                               "columnName": 'Jan',
                                      //                               "width": '125px',
                                      //                               "align": "right",
                                      //                               "sortable": true,
                                      //                             },
                                      //                             {
                                      //                               "name": 'Feb',
                                      //                               "columnName": 'Feb',
                                      //                               "width": '125px',
                                      //                               "align": "right",
                                      //                               "sortable": true,
                                      //                             },
                                      //                             {
                                      //                               "name": 'Mar',
                                      //                               "columnName": 'Mar',
                                      //                               "width": '125px',
                                      //                               "align": "right",
                                      //                               "sortable": true,
                                      //                             },
                                      //                             {
                                      //                               "name": 'Apr',
                                      //                               "columnName": 'Apr',
                                      //                               "width": '125px',
                                      //                               "align": "right",
                                      //                               "sortable": true,
                                      //                             },
                                      //                             {
                                      //                               "name": 'May',
                                      //                               "columnName": 'May',
                                      //                               "width": '125px',
                                      //                               "align": "right",
                                      //                               "sortable": true,
                                      //                             },
                                      //                             {
                                      //                               "name": 'Jun',
                                      //                               "columnName": 'Jun',
                                      //                               "width": '125px',
                                      //                               "align": "right",
                                      //                               "sortable": true,
                                      //                             },
                                      //                             {
                                      //                               "name": 'Jul',
                                      //                               "columnName": 'Jul',
                                      //                               "width": '125px',
                                      //                               "align": "right",
                                      //                               "sortable": true,
                                      //                             },
                                      //                             {
                                      //                               "name": 'Aug',
                                      //                               "columnName": 'Aug',
                                      //                               "width": '125px',
                                      //                               "align": "right",
                                      //                               "sortable": true,
                                      //                             },
                                      //                             {
                                      //                               "name": 'Sep',
                                      //                               "columnName": 'Sep',
                                      //                               "width": '125px',
                                      //                               "align": "right",
                                      //                               "sortable": true,
                                      //                             },
                                      //                             {
                                      //                               "name": 'Oct',
                                      //                               "columnName": 'Oct',
                                      //                               "width": '125px',
                                      //                               "align": "right",
                                      //                               "sortable": true,
                                      //                             },
                                      //                             {
                                      //                               "name": 'Nov',
                                      //                               "columnName": 'Nov',
                                      //                               "width": '125px',
                                      //                               "align": "right",
                                      //                               "sortable": true,
                                      //                             },
                                      //                             {
                                      //                               "name": 'Dec',
                                      //                               "columnName": 'Dec',
                                      //                               "width": '125px',
                                      //                               "align": "right",
                                      //                               "sortable": true,
                                      //                             },
                                      //                             {
                                      //                               "name": 'Total Sales',
                                      //                               "columnName": 'TotalSales',
                                      //                               "width": '125px',
                                      //                               "align": "right",
                                      //                               "sortable": true
                                      //                             }
                                      //                           ],
                                      //                           "title": 'ItemName',
                                      //                           "endpoint": "D21.4",
                                      //                           "parameters": [
                                      //                             { "key": "FromMonth", "value": "2024" },
                                      //                             { "key": "FromYear", "value": "1" },
                                      //                             { "key": "ToMonth", "value": "2024" },
                                      //                             { "key": "ToYear", "value": "1" },
                                      //                             { "key": "DistributorCodeRegionCode", "value": "" },
                                      //                             { "key": "DistrictManagerCode", "value": "" },
                                      //                             { "key": "ConfigTypeCode", "value": "" }
                                      //                           ]
                                      //                         },
                                      //                         "context": {
                                      //                           "point": {
                                      //                             "onClick": {
  
                                      //                             }
                                      //                           }
                                      //                         }
                                      //                       }
                                      //                     }
                                      //                   }
                                      //                 ],
                                      //               }
                                      //             }
                                      //           }
                                      //         }
                                      //       }
                                      //     }
                                      //   ]
                                      // },
                                      {
                                        "title": "District",
                                        "visual": [
                                          {
                                            "columns": 12,
                                            "rows": 2,
                                            "visual": {
                                              "id": 1,
                                              "type": "advancedTable",
                                              "colorTheme": "colorTheme1",
                                              "title": "District",
                                              "binding": {
                                                "data": {
                                                  "columns": [
                                                    {
                                                      "name": 'District',
                                                      "columnName": 'DistrictName',
                                                      "width": '150px',
                                                      "align": "left",
                                                      "sortable": true,
                                                    }
                                                  ],
                                                  "title": 'DistrictName',
                                                  "endpoint": "D21.13",
                                                  "parameters": [
                                                    { "key": "FromMonth", "value": "2024" },
                                                    { "key": "FromYear", "value": "1" },
                                                    { "key": "ToMonth", "value": "2024" },
                                                    { "key": "ToYear", "value": "1" },
                                                    { "key": "DistributorCode", "value": "" },
                                                    { "key": "DistrictManagerCode", "value": "" },
                                                    { "key": "ConfigTypeCode", "value": "" }
                                                  ]
                                                },
                                                "context": {
                                                  "point": {
                                                    "onClick": {
                                                      "selectedValueColumn": "DistributorCodeDistrictName",
                                                      "selectedTitle": "Product",
                                                      "visual": [
                                                        {
                                                          "columns": 12,
                                                          "rows": 2,
                                                          "visual": {
                                                            "id": 1,
                                                            "type": "advancedTable",
                                                            "colorTheme": "colorTheme1",
                                                            "title": "Product",
                                                            "binding": {
                                                              "data": {
                                                                "columns": [
                                                                  {
                                                                    "name": 'Product Name',
                                                                    "columnName": 'ItemName',
                                                                    "width": '200px',
                                                                    "align": "left",
                                                                    "sortable": true,
                                                                  },
                                                                  {
                                                                    "name": 'Jan',
                                                                    "columnName": 'Jan',
                                                                    "width": '125px',
                                                                    "align": "right",
                                                                    "sortable": true,
                                                                  },
                                                                  {
                                                                    "name": 'Feb',
                                                                    "columnName": 'Feb',
                                                                    "width": '125px',
                                                                    "align": "right",
                                                                    "sortable": true,
                                                                  },
                                                                  {
                                                                    "name": 'Mar',
                                                                    "columnName": 'Mar',
                                                                    "width": '125px',
                                                                    "align": "right",
                                                                    "sortable": true,
                                                                  },
                                                                  {
                                                                    "name": 'Apr',
                                                                    "columnName": 'Apr',
                                                                    "width": '125px',
                                                                    "align": "right",
                                                                    "sortable": true,
                                                                  },
                                                                  {
                                                                    "name": 'May',
                                                                    "columnName": 'May',
                                                                    "width": '125px',
                                                                    "align": "right",
                                                                    "sortable": true,
                                                                  },
                                                                  {
                                                                    "name": 'Jun',
                                                                    "columnName": 'Jun',
                                                                    "width": '125px',
                                                                    "align": "right",
                                                                    "sortable": true,
                                                                  },
                                                                  {
                                                                    "name": 'Jul',
                                                                    "columnName": 'Jul',
                                                                    "width": '125px',
                                                                    "align": "right",
                                                                    "sortable": true,
                                                                  },
                                                                  {
                                                                    "name": 'Aug',
                                                                    "columnName": 'Aug',
                                                                    "width": '125px',
                                                                    "align": "right",
                                                                    "sortable": true,
                                                                  },
                                                                  {
                                                                    "name": 'Sep',
                                                                    "columnName": 'Sep',
                                                                    "width": '125px',
                                                                    "align": "right",
                                                                    "sortable": true,
                                                                  },
                                                                  {
                                                                    "name": 'Oct',
                                                                    "columnName": 'Oct',
                                                                    "width": '125px',
                                                                    "align": "right",
                                                                    "sortable": true,
                                                                  },
                                                                  {
                                                                    "name": 'Nov',
                                                                    "columnName": 'Nov',
                                                                    "width": '125px',
                                                                    "align": "right",
                                                                    "sortable": true,
                                                                  },
                                                                  {
                                                                    "name": 'Dec',
                                                                    "columnName": 'Dec',
                                                                    "width": '125px',
                                                                    "align": "right",
                                                                    "sortable": true,
                                                                  },
                                                                  {
                                                                    "name": 'Total Sales',
                                                                    "columnName": 'TotalSales',
                                                                    "width": '125px',
                                                                    "align": "right",
                                                                    "sortable": true,
                                                                  }
                                                                ],
                                                                "title": 'ItemName',
                                                                "endpoint": "D21.14",
                                                                "parameters": [
                                                                  { "key": "FromMonth", "value": "2024" },
                                                                  { "key": "FromYear", "value": "1" },
                                                                  { "key": "ToMonth", "value": "2024" },
                                                                  { "key": "ToYear", "value": "1" },
                                                                  { "key": "DistributorCodeDistrictName", "value": "" },
                                                                  { "key": "DistrictManagerCode", "value": "" },
                                                                  { "key": "ConfigTypeCode", "value": "" }
                                                                ]
                                                              },
                                                              "context": {
                                                                "point": {
                                                                  "onClick": {
  
                                                                  }
                                                                }
                                                              }
                                                            }
                                                          }
                                                        }
                                                      ],
                                                    }
                                                  }
                                                }
                                              }
                                            }
                                          }
                                        ]
                                      },
                                      {
                                        "title": "PMR",
                                        "visual": [
                                          {
                                            "columns": 12,
                                            "rows": 2,
                                            "visual": {
                                              "id": 1,
                                              "type": "advancedTable",
                                              "colorTheme": "colorTheme1",
                                              "title": "PMR",
                                              "binding": {
                                                "data": {
                                                  "columns": [
                                                    {
                                                      "name": 'PMR Code',
                                                      "columnName": 'AgentCode',
                                                      "width": '170px',
                                                      "align": "left",
                                                      "sortable": true,
                                                    },
                                                    {
                                                      "name": 'Employee Code',
                                                      "columnName": 'EmployeeCode',
                                                      "width": '170px',
                                                      "align": "left",
                                                      "sortable": true
                                                    },
                                                    {
                                                      "name": 'PMR Name',
                                                      "columnName": 'AgentName',
                                                      "width": '200px',
                                                      "align": "left",
                                                      "sortable": true,
                                                    },
                                                    {
                                                      "name": 'Area Name',
                                                      "columnName": 'TerritoryName',
                                                      "width": '350px',
                                                      "align": "left",
                                                      "sortable": true,
                                                    },
                                                    {
                                                      "name": 'District Name',
                                                      "columnName": 'DistrictName',
                                                      "width": '200px',
                                                      "align": "left",
                                                      "sortable": true,
                                                    },
                                                    {
                                                      "name": 'Region',
                                                      "columnName": 'RegionCode',
                                                      "width": '110px',
                                                      "align": "left",
                                                      "sortable": true,
                                                    }
                                                  ],
                                                  "title": 'AgentName',
                                                  "endpoint": "D21.10",
                                                  "parameters": [
                                                    { "key": "FromMonth", "value": "2024" },
                                                    { "key": "FromYear", "value": "1" },
                                                    { "key": "ToMonth", "value": "2024" },
                                                    { "key": "ToYear", "value": "1" },
                                                    { "key": "DistributorCode", "value": "" },
                                                    { "key": "DistrictManagerCode", "value": "" },
                                                    { "key": "ConfigTypeCode", "value": "" }
                                                  ]
                                                },
                                                "context": {
                                                  "point": {
                                                    "onClick": {
                                                      "selectedValueColumn": "DistributorCodeAgentCodeTerritoryDistrictRegion",
                                                      "selectedTitle": "Product",
                                                      "visual": [
                                                        {
                                                          "columns": 12,
                                                          "rows": 2,
                                                          "visual": {
                                                            "id": 1,
                                                            "type": "advancedTable",
                                                            "colorTheme": "colorTheme1",
                                                            "title": "Product",
                                                            "binding": {
                                                              "data": {
                                                                "columns": [
                                                                  {
                                                                    "name": 'Product Name',
                                                                    "columnName": 'ItemName',
                                                                    "width": '200px',
                                                                    "align": "left",
                                                                    "sortable": true,
                                                                  },
                                                                  {
                                                                    "name": 'Jan',
                                                                    "columnName": 'Jan',
                                                                    "width": '125px',
                                                                    "align": "right",
                                                                    "sortable": true,
                                                                  },
                                                                  {
                                                                    "name": 'Feb',
                                                                    "columnName": 'Feb',
                                                                    "width": '125px',
                                                                    "align": "right",
                                                                    "sortable": true,
                                                                  },
                                                                  {
                                                                    "name": 'Mar',
                                                                    "columnName": 'Mar',
                                                                    "width": '125px',
                                                                    "align": "right",
                                                                    "sortable": true,
                                                                  },
                                                                  {
                                                                    "name": 'Apr',
                                                                    "columnName": 'Apr',
                                                                    "width": '125px',
                                                                    "align": "right",
                                                                    "sortable": true,
                                                                  },
                                                                  {
                                                                    "name": 'May',
                                                                    "columnName": 'May',
                                                                    "width": '125px',
                                                                    "align": "right",
                                                                    "sortable": true,
                                                                  },
                                                                  {
                                                                    "name": 'Jun',
                                                                    "columnName": 'Jun',
                                                                    "width": '125px',
                                                                    "align": "right",
                                                                    "sortable": true,
                                                                  },
                                                                  {
                                                                    "name": 'Jul',
                                                                    "columnName": 'Jul',
                                                                    "width": '125px',
                                                                    "align": "right",
                                                                    "sortable": true,
                                                                  },
                                                                  {
                                                                    "name": 'Aug',
                                                                    "columnName": 'Aug',
                                                                    "width": '125px',
                                                                    "align": "right",
                                                                    "sortable": true,
                                                                  },
                                                                  {
                                                                    "name": 'Sep',
                                                                    "columnName": 'Sep',
                                                                    "width": '125px',
                                                                    "align": "right",
                                                                    "sortable": true,
                                                                  },
                                                                  {
                                                                    "name": 'Oct',
                                                                    "columnName": 'Oct',
                                                                    "width": '125px',
                                                                    "align": "right",
                                                                    "sortable": true,
                                                                  },
                                                                  {
                                                                    "name": 'Nov',
                                                                    "columnName": 'Nov',
                                                                    "width": '125px',
                                                                    "align": "right",
                                                                    "sortable": true,
                                                                  },
                                                                  {
                                                                    "name": 'Dec',
                                                                    "columnName": 'Dec',
                                                                    "width": '125px',
                                                                    "align": "right",
                                                                    "sortable": true,
                                                                  },
                                                                  {
                                                                    "name": 'Total Sales',
                                                                    "columnName": 'TotalSales',
                                                                    "width": '125px',
                                                                    "align": "right",
                                                                    "sortable": true,
                                                                  }
                                                                ],
                                                                "title": 'ItemName',
                                                                "endpoint": "D21.6",
                                                                "parameters": [
                                                                  { "key": "FromMonth", "value": "2024" },
                                                                  { "key": "FromYear", "value": "1" },
                                                                  { "key": "ToMonth", "value": "2024" },
                                                                  { "key": "ToYear", "value": "1" },
                                                                  { "key": "DistributorCodeAgentCodeTerritoryDistrictRegion", "value": "" },
                                                                  { "key": "DistrictManagerCode", "value": "" },
                                                                  { "key": "ConfigTypeCode", "value": "" }
                                                                ]
                                                              },
                                                              "context": {
                                                                "point": {
                                                                  "onClick": {
  
                                                                  }
                                                                }
                                                              }
                                                            }
                                                          }
                                                        }
                                                      ]
                                                    }
                                                  }
                                                }
                                              }
                                            }
                                          }
                                        ]
                                      }
                                    ]
  
                                  }
                                }
                              }
                            }
                          }
                        }
                      ]
                    }
                  ]
                }
              }
            }
          }
        }
      },
      {
        "columns": 12,
        "rows": 2,
        "visual": {
          "id": 1,
          "type": "advancedTable",
          "colorTheme": "colorTheme1",
          "title": "Product Sales Growth & Performance",
          "binding": {
            "data": {
              "columns": [
                {
                  "name": 'Product Name',
                  "columnName": 'ItemName',
                  "width": '250px',
                  "align": "left",
                  "sortable": true,
                  "sum": false
                },
                {
                  "name": 'Sales (PESO)',
                  "columnName": 'ActualSales(Value)',
                  "width": '140px',
                  "align": "right",
                  "sortable": true,
                  "sum": true
                },
                {
                  "name": 'LYSales (PESO)',
                  "columnName": 'LYSales(Value)',
                  "width": '150px',
                  "align": "right",
                  "sortable": true,
                  "sum": true
                },
                {
                  "name": '% Growth (PESO)',
                  "columnName": 'Growth(Value)',
                  "width": '170px',
                  "align": "right",
                  "sortable": true,
                  "sum": false,
                  "percent": true
                },
                {
                  "name": 'Target (PESO)',
                  "columnName": 'TargetSales(Value)',
                  "width": '170px',
                  "align": "right",
                  "sortable": true,
                  "sum": true
                },
                {
                  "name": '% Performance (PESO)',
                  "columnName": 'Performance(Value)',
                  "width": '210px',
                  "align": "right",
                  "sortable": true,
                  "sum": false,
                  "percent": true
                },
                {
                  "name": 'Sales (UNIT)',
                  "columnName": 'ActualSales(Qty)',
                  "width": '140px',
                  "align": "right",
                  "sortable": true
                },
                {
                  "name": 'LYSales (UNIT)',
                  "columnName": 'LYSales(Qty)',
                  "width": '150px',
                  "align": "right",
                  "sortable": true
                },
                {
                  "name": '% Growth (UNIT)',
                  "columnName": 'Growth(Qty)',
                  "width": '170px',
                  "align": "right",
                  "sortable": true,
                  "sum": false,
                  "percent": true
                },
                {
                  "name": 'Target (UNIT)',
                  "columnName": 'TargetSales(Qty)',
                  "width": '170px',
                  "align": "right",
                  "sortable": true,
                  "sum": false
                },
                {
                  "name": '% Performance (UNIT)',
                  "columnName": 'Performance(Qty)',
                  "width": '210px',
                  "align": "right",
                  "sortable": true,
                  "sum": false,
                  "percent": true
                }
              ],
              "title": 'ItemName',
              "endpoint": "D08",
              "parameters": [
                { "key": "FromMonth", "value": "2024" },
                { "key": "FromYear", "value": "1" },
                { "key": "ToMonth", "value": "2024" },
                { "key": "ToYear", "value": "1" },
                { "key": "DistrictManagerCode", "value": "" },
                { "key": "ConfigTypeCode", "value": "" }
              ]
            },
            "context": {
              "point": {
                "onClick": {
                  "selectedValueColumn": "ItemName",
                  "visuals": [
                    {
                      "title": "District",
                      "visual": [
                        {
                          "columns": 12,
                          "rows": 2,
                          "visual": {
                            "id": 1,
                            "type": "advancedTable",
                            "colorTheme": "colorTheme1",
                            "title": "District",
                            "binding": {
                              "data": {
                                "columns": [
                                  {
                                    "name": 'District',
                                    "columnName": 'DistrictName',
                                    "width": '250px',
                                    "align": "left",
                                    "sortable": true,
                                    "sum": false
                                  },
                                  {
                                    "name": 'Sales (PESO)',
                                    "columnName": 'ActualSales(Value)',
                                    "width": '140px',
                                    "align": "right",
                                    "sortable": true,
                                    "sum": true
                                  },
                                  {
                                    "name": 'LYSales (PESO)',
                                    "columnName": 'LYSales(Value)',
                                    "width": '150px',
                                    "align": "right",
                                    "sortable": true,
                                    "sum": true
                                  },
                                  {
                                    "name": '% Growth (PESO)',
                                    "columnName": 'Growth(Value)',
                                    "width": '170px',
                                    "align": "right",
                                    "sortable": true,
                                    "sum": false,
                                    "percent": true
                                  },
                                  {
                                    "name": 'Target (PESO)',
                                    "columnName": 'TargetSales(Value)',
                                    "width": '170px',
                                    "align": "right",
                                    "sortable": true,
                                    "sum": true
                                  },
                                  {
                                    "name": '% Performance (PESO)',
                                    "columnName": 'Performance(Value)',
                                    "width": '210px',
                                    "align": "right",
                                    "sortable": true,
                                    "sum": false,
                                    "percent": true
                                  },
                                  {
                                    "name": 'Sales (UNIT)',
                                    "columnName": 'ActualSales(Qty)',
                                    "width": '140px',
                                    "align": "right",
                                    "sortable": true
                                  },
                                  {
                                    "name": 'LYSales (UNIT)',
                                    "columnName": 'LYSales(Qty)',
                                    "width": '150px',
                                    "align": "right",
                                    "sortable": true
                                  },
                                  {
                                    "name": '% Growth (UNIT)',
                                    "columnName": 'Growth(Qty)',
                                    "width": '170px',
                                    "align": "right",
                                    "sortable": true,
                                    "sum": false,
                                    "percent": true
                                  },
                                  {
                                    "name": 'Target (UNIT)',
                                    "columnName": 'TargetSales(Qty)',
                                    "width": '170px',
                                    "align": "right",
                                    "sortable": true,
                                    "sum": false
                                  },
                                  {
                                    "name": '% Performance (UNIT)',
                                    "columnName": 'Performance(Qty)',
                                    "width": '210px',
                                    "align": "right",
                                    "sortable": true,
                                    "sum": false,
                                    "percent": true
                                  }
                                ],
                                "title": 'RegionCode',
                                "endpoint": "D08.3",
                                "parameters": [
                                  { "key": "FromMonth", "value": "2024" },
                                  { "key": "FromYear", "value": "1" },
                                  { "key": "ToMonth", "value": "2024" },
                                  { "key": "ToYear", "value": "1" },
                                  { "key": "DistrictManagerCode", "value": "" },
                                  { "key": "ItemName", "value": "" },
                                  { "key": "ConfigTypeCode", "value": "" }
                                ]
                              },
                              "context": {
                                "point": {
                                  "onClick": {
  
                                  }
                                }
                              }
                            }
                          }
                        }
                      ]
                    },
                    {
                      "title": "PMR",
                      "visual": [
                        {
                          "columns": 12,
                          "rows": 2,
                          "visual": {
                            "id": 1,
                            "type": "advancedTable",
                            "colorTheme": "colorTheme1",
                            "title": "PMR",
                            "binding": {
                              "data": {
                                "columns": [
                                  {
                                    "name": 'PMR Code',
                                    "columnName": 'AgentCode',
                                    "width": '150px',
                                    "align": "left",
                                    "sortable": true,
                                    "sum": false
                                  },
                                  {
                                    "name": 'Employee Code',
                                    "columnName": 'EmployeeCode',
                                    "width": '160px',
                                    "align": "left",
                                    "sortable": true,
                                    "sum": false
                                  },
                                  {
                                    "name": 'PMR Name',
                                    "columnName": 'AgentName',
                                    "width": '250px',
                                    "align": "left",
                                    "sortable": true,
                                    "sum": false
                                  },
                                  {
                                    "name": 'Sales (PESO)',
                                    "columnName": 'ActualSales(Value)',
                                    "width": '140px',
                                    "align": "right",
                                    "sortable": true,
                                    "sum": true
                                  },
                                  {
                                    "name": 'LYSales (PESO)',
                                    "columnName": 'LYSales(Value)',
                                    "width": '150px',
                                    "align": "right",
                                    "sortable": true,
                                    "sum": true
                                  },
                                  {
                                    "name": '% Growth (PESO)',
                                    "columnName": 'Growth(Value)',
                                    "width": '170px',
                                    "align": "right",
                                    "sortable": true,
                                    "sum": false,
                                    "percent": true
                                  },
                                  {
                                    "name": 'Target (PESO)',
                                    "columnName": 'TargetSales(Value)',
                                    "width": '170px',
                                    "align": "right",
                                    "sortable": true,
                                    "sum": true
                                  },
                                  {
                                    "name": '% Performance (PESO)',
                                    "columnName": 'Performance(Value)',
                                    "width": '210px',
                                    "align": "right",
                                    "sortable": true,
                                    "sum": false,
                                    "percent": true
                                  },
                                  {
                                    "name": 'Sales (UNIT)',
                                    "columnName": 'ActualSales(Qty)',
                                    "width": '140px',
                                    "align": "right",
                                    "sortable": true
                                  },
                                  {
                                    "name": 'LYSales (UNIT)',
                                    "columnName": 'LYSales(Qty)',
                                    "width": '150px',
                                    "align": "right",
                                    "sortable": true
                                  },
                                  {
                                    "name": '% Growth (UNIT)',
                                    "columnName": 'Growth(Qty)',
                                    "width": '170px',
                                    "align": "right",
                                    "sortable": true,
                                    "sum": false,
                                    "percent": true
                                  },
                                  {
                                    "name": 'Target (UNIT)',
                                    "columnName": 'TargetSales(Qty)',
                                    "width": '170px',
                                    "align": "right",
                                    "sortable": true,
                                    "sum": false
                                  },
                                  {
                                    "name": '% Performance (UNIT)',
                                    "columnName": 'Performance(Qty)',
                                    "width": '210px',
                                    "align": "right",
                                    "sortable": true,
                                    "sum": false,
                                    "percent": true
                                  }
                                ],
                                "title": 'AgentName',
                                "endpoint": "D08.2",
                                "parameters": [
                                  { "key": "FromMonth", "value": "2024" },
                                  { "key": "FromYear", "value": "1" },
                                  { "key": "ToMonth", "value": "2024" },
                                  { "key": "ToYear", "value": "1" },
                                  { "key": "DistrictManagerCode", "value": "" },
                                  { "key": "ItemName", "value": "" },
                                  { "key": "ConfigTypeCode", "value": "" }
                                ]
                              },
                              "context": {
                                "point": {
                                  "onClick": {
  
                                  }
                                }
                              }
                            }
                          }
                        }
                      ]
                    }
                  ]
                }
              }
            }
          }
        }
      },
      {
        "columns": 12,
        "rows": 2,
        "visual": {
          "id": 1,
          "type": "advancedTable",
          "colorTheme": "colorTheme1",
          "title": "Product Sales by Channel (PESO)",
          "binding": {
            "data": {
              "columns": [
                {
                  "name": 'Channel',
                  "columnName": 'DistributorCode',
                  "width": '150px',
                  "align": "left",
                  "sortable": true,
                },
                {
                  "name": 'Actual Sales',
                  "columnName": 'ActualSales(Value)',
                  "width": '140px',
                  "align": "right",
                  "sortable": true,
                  "sum": true
                },
                {
                  "name": 'LYSales',
                  "columnName": 'LYSales(Value)',
                  "width": '150px',
                  "align": "right",
                  "sortable": true,
                  "sum": true
                },
                {
                  "name": 'Growth %',
                  "columnName": 'Growth(Value)',
                  "width": '170px',
                  "align": "right",
                  "sortable": true,
                  "sum": false,
                  "percent": true
                }
              ],
              "title": 'DistributorName',
              "endpoint": "D22",
              "parameters": [
                { "key": "FromMonth", "value": "2024" },
                { "key": "FromYear", "value": "1" },
                { "key": "ToMonth", "value": "2024" },
                { "key": "ToYear", "value": "1" },
                { "key": "DistrictManagerCode", "value": "" },
                { "key": "ConfigTypeCode", "value": "" }
              ]
            },
            "context": {
              "point": {
                "onClick": {
                  "selectedValueColumn": "DistributorCode",
                  "visuals": [
                    // {
                    //   "title": "Region",
                    //   "visual": [
                    //     {
                    //       "columns": 12,
                    //       "rows": 2,
                    //       "visual": {
                    //         "id": 1,
                    //         "type": "advancedTable",
                    //         "colorTheme": "colorTheme1",
                    //         "title": "Region",
                    //         "binding": {
                    //           "data": {
                    //             "columns": [
                    //               {
                    //                 "name": 'Region',
                    //                 "columnName": 'RegionCode',
                    //                 "width": '250px',
                    //                 "align": "left",
                    //                 "sortable": true,
                    //                 "sum": false
                    //               },
                    //               {
                    //                 "name": 'Actual Sales',
                    //                 "columnName": 'ActualSales(Value)',
                    //                 "width": '140px',
                    //                 "align": "right",
                    //                 "sortable": true,
                    //                 "sum": true
                    //               },
                    //               {
                    //                 "name": 'LYSales',
                    //                 "columnName": 'LYSales(Value)',
                    //                 "width": '150px',
                    //                 "align": "right",
                    //                 "sortable": true,
                    //                 "sum": true
                    //               },
                    //               {
                    //                 "name": 'Growth %',
                    //                 "columnName": 'Growth(Value)',
                    //                 "width": '170px',
                    //                 "align": "right",
                    //                 "sortable": true,
                    //                 "sum": false,
                    //                 "percent": true
                    //               }
                    //             ],
                    //             "title": 'RegionCode',
                    //             "endpoint": "D22.1",
                    //             "parameters": [
                    //               { "key": "FromMonth", "value": "2024" },
                    //               { "key": "FromYear", "value": "1" },
                    //               { "key": "ToMonth", "value": "2024" },
                    //               { "key": "ToYear", "value": "1" },
                    //               { "key": "DistrictManagerCode", "value": "" },
                    //               { "key": "DistributorCode", "value": "" },
                    //               { "key": "ConfigTypeCode", "value": "" }
                    //             ]
                    //           },
                    //           "context": {
                    //             "point": {
                    //               "onClick": {
  
                    //               }
                    //             }
                    //           }
                    //         }
                    //       }
                    //     }
                    //   ]
                    // },
                    {
                      "title": "District",
                      "visual": [
                        {
                          "columns": 12,
                          "rows": 2,
                          "visual": {
                            "id": 1,
                            "type": "advancedTable",
                            "colorTheme": "colorTheme1",
                            "title": "District",
                            "binding": {
                              "data": {
                                "columns": [
                                  {
                                    "name": 'District',
                                    "columnName": 'DistrictName',
                                    "width": '250px',
                                    "align": "left",
                                    "sortable": true,
                                    "sum": false
                                  },
                                  {
                                    "name": 'Actual Sales',
                                    "columnName": 'ActualSales(Value)',
                                    "width": '140px',
                                    "align": "right",
                                    "sortable": true,
                                    "sum": true
                                  },
                                  {
                                    "name": 'LYSales',
                                    "columnName": 'LYSales(Value)',
                                    "width": '150px',
                                    "align": "right",
                                    "sortable": true,
                                    "sum": true
                                  },
                                  {
                                    "name": 'Growth %',
                                    "columnName": 'Growth(Value)',
                                    "width": '170px',
                                    "align": "right",
                                    "sortable": true,
                                    "sum": false,
                                    "percent": true
                                  }
                                ],
                                "title": 'RegionCode',
                                "endpoint": "D22.3",
                                "parameters": [
                                  { "key": "FromMonth", "value": "2024" },
                                  { "key": "FromYear", "value": "1" },
                                  { "key": "ToMonth", "value": "2024" },
                                  { "key": "ToYear", "value": "1" },
                                  { "key": "DistrictManagerCode", "value": "" },
                                  { "key": "DistributorCode", "value": "" },
                                  { "key": "ConfigTypeCode", "value": "" }
                                ]
                              },
                              "context": {
                                "point": {
                                  "onClick": {
                                    "selectedValueColumn": "DistributorCodeDistrictName",
                                    "selectedTitle": "Product",
                                    "visual": [
                                      {
                                        "columns": 12,
                                        "rows": 2,
                                        "visual": {
                                          "id": 1,
                                          "type": "advancedTable",
                                          "colorTheme": "colorTheme1",
                                          "title": "Product",
                                          "binding": {
                                            "data": {
                                              "columns": [
                                                {
                                                  "name": 'Product Name',
                                                  "columnName": 'ItemName',
                                                  "width": '200px',
                                                  "align": "left",
                                                  "sortable": true,
                                                  "sum": false
                                                },
                                                {
                                                  "name": 'Sales (PESO)',
                                                  "columnName": 'ActualSales(Value)',
                                                  "width": '140px',
                                                  "align": "right",
                                                  "sortable": true,
                                                  "sum": true
                                                },
                                                {
                                                  "name": 'LYSales (PESO)',
                                                  "columnName": 'LYSales(Value)',
                                                  "width": '150px',
                                                  "align": "right",
                                                  "sortable": true,
                                                  "sum": true
                                                },
                                                {
                                                  "name": '% Growth (PESO)',
                                                  "columnName": 'Growth(Value)',
                                                  "width": '170px',
                                                  "align": "right",
                                                  "sortable": true,
                                                  "sum": false,
                                                  "percent": true
                                                },
                                                {
                                                  "name": 'Sales (UNIT)',
                                                  "columnName": 'ActualSales(Qty)',
                                                  "width": '140px',
                                                  "align": "right",
                                                  "sortable": true,
                                                  "sum": true
                                                },
                                                {
                                                  "name": 'LYSales (UNIT)',
                                                  "columnName": 'LYSales(Qty)',
                                                  "width": '150px',
                                                  "align": "right",
                                                  "sortable": true,
                                                  "sum": true
                                                },
                                                {
                                                  "name": '% Growth (UNIT)',
                                                  "columnName": 'Growth(Qty)',
                                                  "width": '170px',
                                                  "align": "right",
                                                  "sortable": true,
                                                  "sum": false,
                                                  "percent": true
                                                }
                                              ],
                                              "title": "ItemName",
                                              "endpoint": "D22.4",
                                              "parameters": [
                                                { "key": "FromMonth", "value": "" },
                                                { "key": "FromYear", "value": "" },
                                                { "key": "ToMonth", "value": "" },
                                                { "key": "ToYear", "value": "" },
                                                { "key": "DistrictManagerCode", "value": "" },
                                                { "key": "DistributorCodeDistrictName", "value": "" },
                                                { "key": "ConfigTypeCode", "value": "" }
                                              ]
                                            },
                                            "context": {
                                              "point": {
                                                "onClick": {
  
                                                }
                                              }
                                            }
                                          }
                                        }
                                      }
                                    ]
                                  }
                                }
                              }
                            }
                          }
                        }
                      ]
                    },
                    {
                      "title": "PMR",
                      "visual": [
                        {
                          "columns": 12,
                          "rows": 2,
                          "visual": {
                            "id": 1,
                            "type": "advancedTable",
                            "colorTheme": "colorTheme1",
                            "title": "PMR",
                            "binding": {
                              "data": {
                                "columns": [
                                  {
                                    "name": 'PMR Code',
                                    "columnName": 'AgentCode',
                                    "width": '150px',
                                    "align": "left",
                                    "sortable": true,
                                    "sum": false
                                  },
                                  {
                                    "name": 'Employee Code',
                                    "columnName": 'EmployeeCode',
                                    "width": '160px',
                                    "align": "left",
                                    "sortable": true,
                                    "sum": false
                                  },
                                  {
                                    "name": 'PMR Name',
                                    "columnName": 'AgentName',
                                    "width": '250px',
                                    "align": "left",
                                    "sortable": true,
                                    "sum": false
                                  },
                                  {
                                    "name": 'Actual Sales',
                                    "columnName": 'ActualSales(Value)',
                                    "width": '140px',
                                    "align": "right",
                                    "sortable": true,
                                    "sum": true
                                  },
                                  {
                                    "name": 'LYSales',
                                    "columnName": 'LYSales(Value)',
                                    "width": '150px',
                                    "align": "right",
                                    "sortable": true,
                                    "sum": true
                                  },
                                  {
                                    "name": 'Growth %',
                                    "columnName": 'Growth(Value)',
                                    "width": '170px',
                                    "align": "right",
                                    "sortable": true,
                                    "sum": false,
                                    "percent": true
                                  }
                                ],
                                "title": 'AgentName',
                                "endpoint": "D22.2",
                                "parameters": [
                                  { "key": "FromMonth", "value": "2024" },
                                  { "key": "FromYear", "value": "1" },
                                  { "key": "ToMonth", "value": "2024" },
                                  { "key": "ToYear", "value": "1" },
                                  { "key": "DistrictManagerCode", "value": "" },
                                  { "key": "DistributorCode", "value": "" },
                                  { "key": "ConfigTypeCode", "value": "" }
                                ]
                              },
                              "context": {
                                "point": {
                                  "onClick": {
                                    "selectedValueColumn": "DistributorCodeAgentNameEmployeeCode",
                                    "selectedTitle": "Product",
                                    "visual": [
                                      {
                                        "columns": 12,
                                        "rows": 2,
                                        "visual": {
                                          "id": 1,
                                          "type": "advancedTable",
                                          "colorTheme": "colorTheme1",
                                          "title": "Product",
                                          "binding": {
                                            "data": {
                                              "columns": [
                                                {
                                                  "name": 'Product Name',
                                                  "columnName": 'ItemName',
                                                  "width": '200px',
                                                  "align": "left",
                                                  "sortable": true,
                                                  "sum": false
                                                },
                                                {
                                                  "name": 'Sales (PESO)',
                                                  "columnName": 'ActualSales(Value)',
                                                  "width": '140px',
                                                  "align": "right",
                                                  "sortable": true,
                                                  "sum": true
                                                },
                                                {
                                                  "name": 'LYSales (PESO)',
                                                  "columnName": 'LYSales(Value)',
                                                  "width": '150px',
                                                  "align": "right",
                                                  "sortable": true,
                                                  "sum": true
                                                },
                                                {
                                                  "name": '% Growth (PESO)',
                                                  "columnName": 'Growth(Value)',
                                                  "width": '170px',
                                                  "align": "right",
                                                  "sortable": true,
                                                  "sum": false,
                                                  "percent": true
                                                },
                                                {
                                                  "name": 'Sales (UNIT)',
                                                  "columnName": 'ActualSales(Qty)',
                                                  "width": '140px',
                                                  "align": "right",
                                                  "sortable": true,
                                                  "sum": true
                                                },
                                                {
                                                  "name": 'LYSales (UNIT)',
                                                  "columnName": 'LYSales(Qty)',
                                                  "width": '150px',
                                                  "align": "right",
                                                  "sortable": true,
                                                  "sum": true
                                                },
                                                {
                                                  "name": '% Growth (UNIT)',
                                                  "columnName": 'Growth(Qty)',
                                                  "width": '170px',
                                                  "align": "right",
                                                  "sortable": true,
                                                  "sum": false,
                                                  "percent": true
                                                }
                                              ],
                                              "title": "ItemName",
                                              "endpoint": "D22.5",
                                              "parameters": [
                                                { "key": "FromMonth", "value": "" },
                                                { "key": "FromYear", "value": "" },
                                                { "key": "ToMonth", "value": "" },
                                                { "key": "ToYear", "value": "" },
                                                { "key": "DistrictManagerCode", "value": "" },
                                                { "key": "DistributorCodeAgentNameEmployeeCode", "value": "" },
                                                { "key": "ConfigTypeCode", "value": "" }
                                              ]
                                            },
                                            "context": {
                                              "point": {
                                                "onClick": {
  
                                                }
                                              }
                                            }
                                          }
                                        }
                                      }
                                    ]
                                  }
                                }
                              }
                            }
                          }
                        }
                      ]
                    }
                  ]
                }
              }
            }
          }
        }
      },
      {
        "columns": 12,
        "rows": 2,
        "visual": {
          "id": 1,
          "type": "advancedTable",
          "colorTheme": "colorTheme1",
          "title": "Product Sales by Customer Group (PESO)",
          "binding": {
            "data": {
              "columns": [
                {
                  "name": 'Customer Group',
                  "columnName": 'CustomerGroup',
                  "width": '300px',
                  "align": "left",
                  "sortable": true,
                  "sum": false
                },
                {
                  "name": 'Actual Sales',
                  "columnName": 'ActualSales(Value)',
                  "width": '140px',
                  "align": "right",
                  "sortable": true,
                  "sum": true
                },
                {
                  "name": 'LYSales',
                  "columnName": 'LYSales(Value)',
                  "width": '150px',
                  "align": "right",
                  "sortable": true,
                  "sum": true
                },
                {
                  "name": 'Growth %',
                  "columnName": 'Growth(Value)',
                  "width": '150px',
                  "align": "right",
                  "sortable": true,
                  "percent": true
                }
              ],
              "title": 'CustomerGroup',
              "endpoint": "D25",
              "parameters": [
                { "key": "FromMonth", "value": "2024" },
                { "key": "FromYear", "value": "1" },
                { "key": "ToMonth", "value": "2024" },
                { "key": "ToYear", "value": "1" },
                { "key": "DistrictManagerCode", "value": "" },
                { "key": "ConfigTypeCode", "value": "" }
              ]
            },
            "context": {
              "point": {
                "onClick": {
                  "selectedValueColumn": 'CustomerGroup',
                  "visuals": [
                    // {
                    //   "title": "Region",
                    //   "visual": [
                    //     {
                    //       "columns": 12,
                    //       "rows": 2,
                    //       "visual": {
                    //         "id": 1,
                    //         "type": "advancedTable",
                    //         "colorTheme": "colorTheme1",
                    //         "title": "Region",
                    //         "binding": {
                    //           "data": {
                    //             "columns": [
                    //               {
                    //                 "name": 'Region',
                    //                 "columnName": 'RegionCode',
                    //                 "width": '150px',
                    //                 "align": "left",
                    //                 "sortable": true,
                    //                 "sum": false
                    //               },
                    //               {
                    //                 "name": 'Actual Sales',
                    //                 "columnName": 'ActualSales(Value)',
                    //                 "width": '140px',
                    //                 "align": "right",
                    //                 "sortable": true,
                    //                 "sum": true
                    //               },
                    //               {
                    //                 "name": 'LYSales',
                    //                 "columnName": 'LYSales(Value)',
                    //                 "width": '150px',
                    //                 "align": "right",
                    //                 "sortable": true,
                    //                 "sum": true
                    //               },
                    //               {
                    //                 "name": 'Growth %',
                    //                 "columnName": 'Growth(Value)',
                    //                 "width": '150px',
                    //                 "align": "right",
                    //                 "sortable": true,
                    //                 "percent": true
                    //               }
                    //             ],
                    //             "title": 'RegionCode',
                    //             "endpoint": "D25.1",
                    //             "parameters": [
                    //               { "key": "FromMonth", "value": "2024" },
                    //               { "key": "FromYear", "value": "1" },
                    //               { "key": "ToMonth", "value": "2024" },
                    //               { "key": "ToYear", "value": "1" },
                    //               { "key": "DistrictManagerCode", "value": "" },
                    //               { "key": "CustomerGroup", "value": "" },
                    //               { "key": "ConfigTypeCode", "value": "" }
                    //             ]
                    //           },
                    //           "context": {
                    //             "point": {
                    //               "onClick": {
  
                    //               }
                    //             }
                    //           }
                    //         }
                    //       }
                    //     }
                    //   ]
                    // },
                    {
                      "title": "District",
                      "visual": [
                        {
                          "columns": 12,
                          "rows": 2,
                          "visual": {
                            "id": 1,
                            "type": "advancedTable",
                            "colorTheme": "colorTheme1",
                            "title": "District",
                            "binding": {
                              "data": {
                                "columns": [
                                  {
                                    "name": 'District',
                                    "columnName": 'DistrictName',
                                    "width": '150px',
                                    "align": "left",
                                    "sortable": true,
                                    "sum": false
                                  },
                                  {
                                    "name": 'Actual Sales',
                                    "columnName": 'ActualSales(Value)',
                                    "width": '140px',
                                    "align": "right",
                                    "sortable": true,
                                    "sum": true
                                  },
                                  {
                                    "name": 'LYSales',
                                    "columnName": 'LYSales(Value)',
                                    "width": '150px',
                                    "align": "right",
                                    "sortable": true,
                                    "sum": true
                                  },
                                  {
                                    "name": 'Growth %',
                                    "columnName": 'Growth(Value)',
                                    "width": '150px',
                                    "align": "right",
                                    "sortable": true,
                                    "percent": true
                                  }
                                ],
                                "title": 'DistrictName',
                                "endpoint": "D25.3",
                                "parameters": [
                                  { "key": "FromMonth", "value": "2024" },
                                  { "key": "FromYear", "value": "1" },
                                  { "key": "ToMonth", "value": "2024" },
                                  { "key": "ToYear", "value": "1" },
                                  { "key": "DistrictManagerCode", "value": "" },
                                  { "key": "CustomerGroup", "value": "" },
                                  { "key": "ConfigTypeCode", "value": "" }
                                ]
                              },
                              "context": {
                                "point": {
                                  "onClick": {
                                    "selectedValueColumn": "CustomerGroupDistrictName",
                                    "selectedTitle": "Product",
                                    "visual": [
                                      {
                                        "columns": 12,
                                        "rows": 2,
                                        "visual": {
                                          "id": 1,
                                          "type": "advancedTable",
                                          "colorTheme": "colorTheme1",
                                          "title": "Product",
                                          "binding": {
                                            "data": {
                                              "columns": [
                                                {
                                                  "name": 'Product Name',
                                                  "columnName": 'ItemName',
                                                  "width": '200px',
                                                  "align": "left",
                                                  "sortable": true,
                                                  "sum": false
                                                },
                                                {
                                                  "name": 'Sales (PESO)',
                                                  "columnName": 'ActualSales(Value)',
                                                  "width": '140px',
                                                  "align": "right",
                                                  "sortable": true,
                                                  "sum": true
                                                },
                                                {
                                                  "name": 'LYSales (PESO)',
                                                  "columnName": 'LYSales(Value)',
                                                  "width": '150px',
                                                  "align": "right",
                                                  "sortable": true,
                                                  "sum": true
                                                },
                                                {
                                                  "name": '% Growth (PESO)',
                                                  "columnName": 'Growth(Value)',
                                                  "width": '170px',
                                                  "align": "right",
                                                  "sortable": true,
                                                  "sum": false,
                                                  "percent": true
                                                },
                                                {
                                                  "name": 'Sales (UNIT)',
                                                  "columnName": 'ActualSales(Qty)',
                                                  "width": '140px',
                                                  "align": "right",
                                                  "sortable": true,
                                                  "sum": true
                                                },
                                                {
                                                  "name": 'LYSales (UNIT)',
                                                  "columnName": 'LYSales(Qty)',
                                                  "width": '150px',
                                                  "align": "right",
                                                  "sortable": true,
                                                  "sum": true
                                                },
                                                {
                                                  "name": '% Growth (UNIT)',
                                                  "columnName": 'Growth(Qty)',
                                                  "width": '170px',
                                                  "align": "right",
                                                  "sortable": true,
                                                  "sum": false,
                                                  "percent": true
                                                }
                                              ],
                                              "title": "ItemName",
                                              "endpoint": "D25.4",
                                              "parameters": [
                                                { "key": "FromMonth", "value": "" },
                                                { "key": "FromYear", "value": "" },
                                                { "key": "ToMonth", "value": "" },
                                                { "key": "ToYear", "value": "" },
                                                { "key": "DistrictManagerCode", "value": "" },
                                                { "key": "CustomerGroupDistrictName", "value": "" },
                                                { "key": "ConfigTypeCode", "value": "" }
                                              ]
                                            },
                                            "context": {
                                              "point": {
                                                "onClick": {
  
                                                }
                                              }
                                            }
                                          }
                                        }
                                      }
                                    ]
                                  }
                                }
                              }
                            }
                          }
                        }
                      ]
                    },
                    {
                      "title": "PMR",
                      "visual": [
                        {
                          "columns": 12,
                          "rows": 2,
                          "visual": {
                            "id": 1,
                            "type": "advancedTable",
                            "colorTheme": "colorTheme1",
                            "title": "PMR",
                            "binding": {
                              "data": {
                                "columns": [
                                  {
                                    "name": 'PMR Code',
                                    "columnName": 'AgentCode',
                                    "width": '150px',
                                    "align": "left",
                                    "sortable": true,
                                    "sum": false
                                  },
                                  {
                                    "name": 'Employee Code',
                                    "columnName": 'EmployeeCode',
                                    "width": '160px',
                                    "align": "left",
                                    "sortable": true,
                                    "sum": false
                                  },
                                  {
                                    "name": 'PMR Name',
                                    "columnName": 'AgentName',
                                    "width": '150px',
                                    "align": "left",
                                    "sortable": true,
                                    "sum": false
                                  },
                                  {
                                    "name": 'Actual Sales',
                                    "columnName": 'ActualSales(Value)',
                                    "width": '140px',
                                    "align": "right",
                                    "sortable": true,
                                    "sum": true
                                  },
                                  {
                                    "name": 'LYSales',
                                    "columnName": 'LYSales(Value)',
                                    "width": '150px',
                                    "align": "right",
                                    "sortable": true,
                                    "sum": true
                                  },
                                  {
                                    "name": 'Growth %',
                                    "columnName": 'Growth(Value)',
                                    "width": '150px',
                                    "align": "right",
                                    "sortable": true,
                                    "percent": true
                                  }
                                ],
                                "title": 'AgentName',
                                "endpoint": "D25.2",
                                "parameters": [
                                  { "key": "FromMonth", "value": "2024" },
                                  { "key": "FromYear", "value": "1" },
                                  { "key": "ToMonth", "value": "2024" },
                                  { "key": "ToYear", "value": "1" },
                                  { "key": "DistrictManagerCode", "value": "" },
                                  { "key": "CustomerGroup", "value": "" },
                                  { "key": "ConfigTypeCode", "value": "" }
                                ]
                              },
                              "context": {
                                "point": {
                                  "onClick": {
                                    "selectedValueColumn": "CustomerGroupAgentNameEmployeeCode",
                                    "selectedTitle": "Product",
                                    "visual": [
                                      {
                                        "columns": 12,
                                        "rows": 2,
                                        "visual": {
                                          "id": 1,
                                          "type": "advancedTable",
                                          "colorTheme": "colorTheme1",
                                          "title": "Product",
                                          "binding": {
                                            "data": {
                                              "columns": [
                                                {
                                                  "name": 'Product Name',
                                                  "columnName": 'ItemName',
                                                  "width": '200px',
                                                  "align": "left",
                                                  "sortable": true,
                                                  "sum": false
                                                },
                                                {
                                                  "name": 'Sales (PESO)',
                                                  "columnName": 'ActualSales(Value)',
                                                  "width": '140px',
                                                  "align": "right",
                                                  "sortable": true,
                                                  "sum": true
                                                },
                                                {
                                                  "name": 'LYSales (PESO)',
                                                  "columnName": 'LYSales(Value)',
                                                  "width": '150px',
                                                  "align": "right",
                                                  "sortable": true,
                                                  "sum": true
                                                },
                                                {
                                                  "name": '% Growth (PESO)',
                                                  "columnName": 'Growth(Value)',
                                                  "width": '170px',
                                                  "align": "right",
                                                  "sortable": true,
                                                  "sum": false,
                                                  "percent": true
                                                },
                                                {
                                                  "name": 'Sales (UNIT)',
                                                  "columnName": 'ActualSales(Qty)',
                                                  "width": '140px',
                                                  "align": "right",
                                                  "sortable": true,
                                                  "sum": true
                                                },
                                                {
                                                  "name": 'LYSales (UNIT)',
                                                  "columnName": 'LYSales(Qty)',
                                                  "width": '150px',
                                                  "align": "right",
                                                  "sortable": true,
                                                  "sum": true
                                                },
                                                {
                                                  "name": '% Growth (UNIT)',
                                                  "columnName": 'Growth(Qty)',
                                                  "width": '170px',
                                                  "align": "right",
                                                  "sortable": true,
                                                  "sum": false,
                                                  "percent": true
                                                }
                                              ],
                                              "title": "ItemName",
                                              "endpoint": "D25.5",
                                              "parameters": [
                                                { "key": "FromMonth", "value": "" },
                                                { "key": "FromYear", "value": "" },
                                                { "key": "ToMonth", "value": "" },
                                                { "key": "ToYear", "value": "" },
                                                { "key": "DistrictManagerCode", "value": "" },
                                                { "key": "CustomerGroupAgentNameEmployeeCode", "value": "" },
                                                { "key": "ConfigTypeCode", "value": "" }
                                              ]
                                            },
                                            "context": {
                                              "point": {
                                                "onClick": {
  
                                                }
                                              }
                                            }
                                          }
                                        }
                                      }
                                    ]
                                  }
                                }
                              }
                            }
                          }
                        }
                      ]
                    }
                  ]
                }
              }
            }
          }
        }
      }
    ]
  }